// LINE 28 - Modernizr-3.7.1.min.js // LINE 34 - Glider //  LINE 611 - js-cookie // LINE 760 - AlertifyJS

// Avoid `console` errors in browsers that lack a console.
(function() {
  var method;
  var noop = function () {};
  var methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
  ];
  var length = methods.length;
  var console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
}());

// Place any jQuery/helper plugins in here.

//Modernizr-3.7.1.min.js
/*! modernizr 3.7.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssanimations-csscolumns-customelements-flexbox-history-picture-pointerevents-postmessage-sizes-srcset-webgl-websockets-webworkers-addtest-domprefixes-hasevent-mq-prefixedcssvalue-prefixes-setclasses-testallprops-testprop-teststyles !*/
!function(e,t,n){function r(e,t){return typeof e===t}function o(e){var t=b.className,n=Modernizr._config.classPrefix||"";if(S&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(e.length>0&&(t+=" "+n+e.join(" "+n)),S?b.className.baseVal=t:b.className=t)}function i(e,t){if("object"==typeof e)for(var n in e)E(e,n)&&i(n,e[n]);else{e=e.toLowerCase();var r=e.split("."),s=Modernizr[r[0]];if(2===r.length&&(s=s[r[1]]),void 0!==s)return Modernizr;t="function"==typeof t?t():t,1===r.length?Modernizr[r[0]]=t:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=t),o([(t&&!1!==t?"":"no-")+r.join("-")]),Modernizr._trigger(e,t)}return Modernizr}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):S?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(){var e=t.body;return e||(e=s(S?"svg":"body"),e.fake=!0),e}function l(e,n,r,o){var i,l,u,f,c="modernizr",d=s("div"),p=a();if(parseInt(r,10))for(;r--;)u=s("div"),u.id=o?o[r]:c+(r+1),d.appendChild(u);return i=s("style"),i.type="text/css",i.id="s"+c,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=c,p.fake&&(p.style.background="",p.style.overflow="hidden",f=b.style.overflow,b.style.overflow="hidden",b.appendChild(p)),l=n(d,e),p.fake?(p.parentNode.removeChild(p),b.style.overflow=f,b.offsetHeight):d.parentNode.removeChild(d),!!l}function u(e,t){return!!~(""+e).indexOf(t)}function f(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function c(t,n,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,t,n);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&t.currentStyle&&t.currentStyle[r];return o}function d(t,r){var o=t.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(f(t[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+f(t[o])+":"+r+")");return i=i.join(" or "),l("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"===c(e,null,"position")})}return n}function p(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function m(e,t,o,i){function a(){f&&(delete L.style,delete L.modElem)}if(i=!r(i,"undefined")&&i,!r(o,"undefined")){var l=d(e,o);if(!r(l,"undefined"))return l}for(var f,c,m,h,v,A=["modernizr","tspan","samp"];!L.style&&A.length;)f=!0,L.modElem=s(A.shift()),L.style=L.modElem.style;for(m=e.length,c=0;c<m;c++)if(h=e[c],v=L.style[h],u(h,"-")&&(h=p(h)),L.style[h]!==n){if(i||r(o,"undefined"))return a(),"pfx"!==t||h;try{L.style[h]=o}catch(e){}if(L.style[h]!==v)return a(),"pfx"!==t||h}return a(),!1}function h(e,t){return function(){return e.apply(t,arguments)}}function v(e,t,n){var o;for(var i in e)if(e[i]in t)return!1===n?e[i]:(o=t[e[i]],r(o,"function")?h(o,n||t):o);return!1}function A(e,t,n,o,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+z.join(s+" ")+s).split(" ");return r(t,"string")||r(t,"undefined")?m(a,t,o,i):(a=(e+" "+x.join(s+" ")+s).split(" "),v(a,t,n))}function g(e,t,r){return A(e,n,n,t,r)}var y=[],w={_version:"3.7.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){y.push({name:e,fn:t,options:n})},addAsyncTest:function(e){y.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=w,Modernizr=new Modernizr;var C=[],b=t.documentElement,S="svg"===b.nodeName.toLowerCase(),_="Moz O ms Webkit",x=w._config.usePrefixes?_.toLowerCase().split(" "):[];w._domPrefixes=x;var T=w._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];w._prefixes=T;var E;!function(){var e={}.hasOwnProperty;E=r(e,"undefined")||r(e.call,"undefined")?function(e,t){return t in e&&r(e.constructor.prototype[t],"undefined")}:function(t,n){return e.call(t,n)}}(),w._l={},w.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},w._trigger=function(e,t){if(this._l[e]){var n=this._l[e];setTimeout(function(){var e;for(e=0;e<n.length;e++)(0,n[e])(t)},0),delete this._l[e]}},Modernizr._q.push(function(){w.addTest=i});var P=function(){function e(e,r){var o;return!!e&&(r&&"string"!=typeof r||(r=s(r||"div")),e="on"+e,o=e in r,!o&&t&&(r.setAttribute||(r=s("div")),r.setAttribute(e,""),o="function"==typeof r[e],r[e]!==n&&(r[e]=n),r.removeAttribute(e)),o)}var t=!("onblur"in b);return e}();w.hasEvent=P;var k=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return l("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"===(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}();w.mq=k;var B=function(e,t){var n=!1,r=s("div"),o=r.style;if(e in o){var i=x.length;for(o[e]=t,n=o[e];i--&&!n;)o[e]="-"+x[i]+"-"+t,n=o[e]}return""===n&&(n=!1),n};w.prefixedCSSValue=B;var z=w._config.usePrefixes?_.split(" "):[];w._cssomPrefixes=z;var O={elem:s("modernizr")};Modernizr._q.push(function(){delete O.elem});var L={style:O.elem.style};Modernizr._q.unshift(function(){delete L.style}),w.testAllProps=A,w.testAllProps=g;w.testProp=function(e,t,r){return m([e],n,t,r)},w.testStyles=l;Modernizr.addTest("customelements","customElements"in e),Modernizr.addTest("history",function(){var t=navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone")||"file:"===location.protocol)&&(e.history&&"pushState"in e.history)}),Modernizr.addTest("pointerevents",function(){var e=!1,t=x.length;for(e=Modernizr.hasEvent("pointerdown");t--&&!e;)P(x[t]+"pointerdown")&&(e=!0);return e});var N=new Boolean("postMessage"in e);N.structuredclones=!0;try{e.postMessage({toString:function(){N.structuredclones=!1}},"*")}catch(e){}Modernizr.addTest("postmessage",N),Modernizr.addTest("webgl",function(){return"WebGLRenderingContext"in e});var R=!1;try{R="WebSocket"in e&&2===e.WebSocket.CLOSING}catch(e){}Modernizr.addTest("websockets",R),Modernizr.addTest("cssanimations",g("animationName","a",!0)),function(){Modernizr.addTest("csscolumns",function(){var e=!1,t=g("columnCount");try{e=!!t,e&&(e=new Boolean(e))}catch(e){}return e});for(var e,t,n=["Width","Span","Fill","Gap","Rule","RuleColor","RuleStyle","RuleWidth","BreakBefore","BreakAfter","BreakInside"],r=0;r<n.length;r++)e=n[r].toLowerCase(),t=g("column"+n[r]),"breakbefore"!==e&&"breakafter"!==e&&"breakinside"!==e||(t=t||g(n[r])),Modernizr.addTest("csscolumns."+e,t)}(),Modernizr.addTest("flexbox",g("flexBasis","1px",!0)),Modernizr.addTest("picture","HTMLPictureElement"in e),Modernizr.addAsyncTest(function(){var e,t,n,r=s("img"),o="sizes"in r;!o&&"srcset"in r?(t="data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==",e="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",n=function(){i("sizes",2===r.width)},r.onload=n,r.onerror=n,r.setAttribute("sizes","9px"),r.srcset=e+" 1w,"+t+" 8w",r.src=e):i("sizes",o)}),Modernizr.addTest("srcset","srcset"in s("img")),Modernizr.addTest("webworkers","Worker"in e),function(){var e,t,n,o,i,s,a;for(var l in y)if(y.hasOwnProperty(l)){if(e=[],t=y[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=o:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=o),C.push((o?"":"no-")+a.join("-"))}}(),o(C),delete w.addTest,delete w.addAsyncTest;for(var j=0;j<Modernizr._q.length;j++)Modernizr._q[j]();e.Modernizr=Modernizr}(window,document);


/* @preserve
    _____ __ _     __                _
   / ___// /(_)___/ /___  ____      (_)___
  / (_ // // // _  // -_)/ __/_    / /(_-<
  \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                              |___/

  Version: 1.7.4
  Author: Nick Piscitelli (pickykneee)
  Website: https://nickpiscitelli.com
  Documentation: http://nickpiscitelli.github.io/Glider.js
  License: MIT License
  Release Date: October 25th, 2018

*/

/* global define */

(function (factory) {
  typeof define === 'function' && define.amd
    ? define(factory)
    : typeof exports === 'object'
      ? (module.exports = factory())
      : factory()
})(function () {
  ('use strict') // eslint-disable-line no-unused-expressions

  /* globals window:true */
  var _window = typeof window !== 'undefined' ? window : this

  var Glider = (_window.Glider = function (element, settings) {
    var _ = this

    if (element._glider) return element._glider

    _.ele = element
    _.ele.classList.add('glider')

    // expose glider object to its DOM element
    _.ele._glider = _

    // merge user setting with defaults
    _.opt = Object.assign(
      {},
      {
        slidesToScroll: 1,
        slidesToShow: 1,
        resizeLock: true,
        duration: 0.5,
        // easeInQuad
        easing: function (x, t, b, c, d) {
          return c * (t /= d) * t + b
        }
      },
      settings
    )

    // set defaults
    _.animate_id = _.page = _.slide = 0
    _.arrows = {}

    // preserve original options to
    // extend breakpoint settings
    _._opt = _.opt

    if (_.opt.skipTrack) {
      // first and only child is the track
      _.track = _.ele.children[0]
    } else {
      // create track and wrap slides
      _.track = document.createElement('div')
      _.ele.appendChild(_.track)
      while (_.ele.children.length !== 1) {
        _.track.appendChild(_.ele.children[0])
      }
    }

    _.track.classList.add('glider-track')

    // start glider
    _.init()

    // set events
    _.resize = _.init.bind(_, true)
    _.event(_.ele, 'add', {
      scroll: _.updateControls.bind(_)
    })
    _.event(_window, 'add', {
      resize: _.resize
    })
  })

  var gliderPrototype = Glider.prototype
  gliderPrototype.init = function (refresh, paging) {
    var _ = this

    var width = 0

    var height = 0

    _.slides = _.track.children;

    [].forEach.call(_.slides, function (_, i) {
      _.classList.add('glider-slide')
      _.setAttribute('data-gslide', i)
    })

    _.containerWidth = _.ele.clientWidth

    var breakpointChanged = _.settingsBreakpoint()
    if (!paging) paging = breakpointChanged

    if (
      _.opt.slidesToShow === 'auto' ||
      typeof _.opt._autoSlide !== 'undefined'
    ) {
      var slideCount = _.containerWidth / _.opt.itemWidth

      _.opt._autoSlide = _.opt.slidesToShow = _.opt.exactWidth
        ? slideCount
        : Math.max(1, Math.floor(slideCount))
    }
    if (_.opt.slidesToScroll === 'auto') {
      _.opt.slidesToScroll = Math.floor(_.opt.slidesToShow)
    }

    _.itemWidth = _.opt.exactWidth
      ? _.opt.itemWidth
      : _.containerWidth / _.opt.slidesToShow;

    // set slide dimensions
    [].forEach.call(_.slides, function (__) {
      __.style.height = 'auto'
      __.style.width = _.itemWidth + 'px'
      width += _.itemWidth
      height = Math.max(__.offsetHeight, height)
    })

    _.track.style.width = width + 'px'
    _.trackWidth = width
    _.isDrag = false
    _.preventClick = false

    _.opt.resizeLock && _.scrollTo(_.slide * _.itemWidth, 0)

    if (breakpointChanged || paging) {
      _.bindArrows()
      _.buildDots()
      _.bindDrag()
    }

    _.updateControls()

    _.emit(refresh ? 'refresh' : 'loaded')
  }

  gliderPrototype.bindDrag = function () {
    var _ = this
    _.mouse = _.mouse || _.handleMouse.bind(_)

    var mouseup = function () {
      _.mouseDown = undefined
      _.ele.classList.remove('drag')
      if (_.isDrag) {
        _.preventClick = true
      }
      _.isDrag = false
    }

    var events = {
      mouseup: mouseup,
      mouseleave: mouseup,
      mousedown: function (e) {
        e.preventDefault()
        e.stopPropagation()
        _.mouseDown = e.clientX
        _.ele.classList.add('drag')
      },
      mousemove: _.mouse,
      click: function (e) {
        if (_.preventClick) {
          e.preventDefault()
          e.stopPropagation()
        }
        _.preventClick = false
      }
    }

    _.ele.classList.toggle('draggable', _.opt.draggable === true)
    _.event(_.ele, 'remove', events)
    if (_.opt.draggable) _.event(_.ele, 'add', events)
  }

  gliderPrototype.buildDots = function () {
    var _ = this

    if (!_.opt.dots) {
      if (_.dots) _.dots.innerHTML = ''
      return
    }

    if (typeof _.opt.dots === 'string') {
      _.dots = document.querySelector(_.opt.dots)
    } else _.dots = _.opt.dots
    if (!_.dots) return

    _.dots.innerHTML = ''
    _.dots.classList.add('glider-dots')

    for (var i = 0; i < Math.ceil(_.slides.length / _.opt.slidesToShow); ++i) {
      var dot = document.createElement('button')
      dot.dataset.index = i
      dot.setAttribute('aria-label', 'Page ' + (i + 1))
      dot.setAttribute('role', 'tab')
      dot.className = 'glider-dot ' + (i ? '' : 'active')
      _.event(dot, 'add', {
        click: _.scrollItem.bind(_, i, true)
      })
      _.dots.appendChild(dot)
    }
  }

  gliderPrototype.bindArrows = function () {
    var _ = this
    if (!_.opt.arrows) {
      Object.keys(_.arrows).forEach(function (direction) {
        var element = _.arrows[direction]
        _.event(element, 'remove', { click: element._func })
      })
      return
    }
    ['prev', 'next'].forEach(function (direction) {
      var arrow = _.opt.arrows[direction]
      if (arrow) {
        if (typeof arrow === 'string') arrow = document.querySelector(arrow)
        if (arrow) {
          arrow._func = arrow._func || _.scrollItem.bind(_, direction)
          _.event(arrow, 'remove', {
            click: arrow._func
          })
          _.event(arrow, 'add', {
            click: arrow._func
          })
          _.arrows[direction] = arrow
        }
      }
    })
  }

  gliderPrototype.updateControls = function (event) {
    var _ = this

    if (event && !_.opt.scrollPropagate) {
      event.stopPropagation()
    }

    var disableArrows = _.containerWidth >= _.trackWidth

    if (!_.opt.rewind) {
      if (_.arrows.prev) {
        _.arrows.prev.classList.toggle(
          'disabled',
          _.ele.scrollLeft <= 0 || disableArrows
        )
        _.arrows.prev.classList.contains('disabled')
          ? _.arrows.prev.setAttribute('aria-disabled', true)
          : _.arrows.prev.setAttribute('aria-disabled', false)
      }
      if (_.arrows.next) {
        _.arrows.next.classList.toggle(
          'disabled',
          Math.ceil(_.ele.scrollLeft + _.containerWidth) >=
          Math.floor(_.trackWidth) || disableArrows
        )
        _.arrows.next.classList.contains('disabled')
          ? _.arrows.next.setAttribute('aria-disabled', true)
          : _.arrows.next.setAttribute('aria-disabled', false)
      }
    }

    _.slide = Math.round(_.ele.scrollLeft / _.itemWidth)
    _.page = Math.round(_.ele.scrollLeft / _.containerWidth)

    var middle = _.slide + Math.floor(Math.floor(_.opt.slidesToShow) / 2)

    var extraMiddle = Math.floor(_.opt.slidesToShow) % 2 ? 0 : middle + 1
    if (Math.floor(_.opt.slidesToShow) === 1) {
      extraMiddle = 0
    }

    // the last page may be less than one half of a normal page width so
    // the page is rounded down. when at the end, force the page to turn
    if (_.ele.scrollLeft + _.containerWidth >= Math.floor(_.trackWidth)) {
      _.page = _.dots ? _.dots.children.length - 1 : 0
    }

    [].forEach.call(_.slides, function (slide, index) {
      var slideClasses = slide.classList

      var wasVisible = slideClasses.contains('visible')

      var start = _.ele.scrollLeft

      var end = _.ele.scrollLeft + _.containerWidth

      var itemStart = _.itemWidth * index

      var itemEnd = itemStart + _.itemWidth;

      [].forEach.call(slideClasses, function (className) {
        /^left|right/.test(className) && slideClasses.remove(className)
      })
      slideClasses.toggle('active', _.slide === index)
      if (middle === index || (extraMiddle && extraMiddle === index)) {
        slideClasses.add('center')
      } else {
        slideClasses.remove('center')
        slideClasses.add(
          [
            index < middle ? 'left' : 'right',
            Math.abs(index - (index < middle ? middle : extraMiddle || middle))
          ].join('-')
        )
      }

      var isVisible =
        Math.ceil(itemStart) >= Math.floor(start) &&
        Math.floor(itemEnd) <= Math.ceil(end)
      slideClasses.toggle('visible', isVisible)
      if (isVisible !== wasVisible) {
        _.emit('slide-' + (isVisible ? 'visible' : 'hidden'), {
          slide: index
        })
      }
    })
    if (_.dots) {
      [].forEach.call(_.dots.children, function (dot, index) {
        dot.classList.toggle('active', _.page === index)
      })
    }

    if (event && _.opt.scrollLock) {
      clearTimeout(_.scrollLock)
      _.scrollLock = setTimeout(function () {
        clearTimeout(_.scrollLock)
        // dont attempt to scroll less than a pixel fraction - causes looping
        if (Math.abs(_.ele.scrollLeft / _.itemWidth - _.slide) > 0.02) {
          if (!_.mouseDown) {
            // Only scroll if not at the end (#94)
            if (_.trackWidth > _.containerWidth + _.ele.scrollLeft) {
              _.scrollItem(_.getCurrentSlide())
            }
          }
        }
      }, _.opt.scrollLockDelay || 250)
    }
  }

  gliderPrototype.getCurrentSlide = function () {
    var _ = this
    return _.round(_.ele.scrollLeft / _.itemWidth)
  }

  gliderPrototype.scrollItem = function (slide, dot, e) {
    if (e) e.preventDefault()

    var _ = this

    var originalSlide = slide
    ++_.animate_id

    if (dot === true) {
      slide = slide * _.containerWidth
      slide = Math.round(slide / _.itemWidth) * _.itemWidth
    } else {
      if (typeof slide === 'string') {
        var backwards = slide === 'prev'

        // use precise location if fractional slides are on
        if (_.opt.slidesToScroll % 1 || _.opt.slidesToShow % 1) {
          slide = _.getCurrentSlide()
        } else {
          slide = _.slide
        }

        if (backwards) slide -= _.opt.slidesToScroll
        else slide += _.opt.slidesToScroll

        if (_.opt.rewind) {
          var scrollLeft = _.ele.scrollLeft
          slide =
            backwards && !scrollLeft
              ? _.slides.length
              : !backwards &&
              scrollLeft + _.containerWidth >= Math.floor(_.trackWidth)
                ? 0
                : slide
        }
      }

      slide = Math.max(Math.min(slide, _.slides.length), 0)

      _.slide = slide
      slide = _.itemWidth * slide
    }

    _.scrollTo(
      slide,
      _.opt.duration * Math.abs(_.ele.scrollLeft - slide),
      function () {
        _.updateControls()
        _.emit('animated', {
          value: originalSlide,
          type:
            typeof originalSlide === 'string' ? 'arrow' : dot ? 'dot' : 'slide'
        })
      }
    )

    return false
  }

  gliderPrototype.settingsBreakpoint = function () {
    var _ = this

    var resp = _._opt.responsive

    if (resp) {
      // Sort the breakpoints in mobile first order
      resp.sort(function (a, b) {
        return b.breakpoint - a.breakpoint
      })

      for (var i = 0; i < resp.length; ++i) {
        var size = resp[i]
        if (_window.innerWidth >= size.breakpoint) {
          if (_.breakpoint !== size.breakpoint) {
            _.opt = Object.assign({}, _._opt, size.settings)
            _.breakpoint = size.breakpoint
            return true
          }
          return false
        }
      }
    }
    // set back to defaults in case they were overriden
    var breakpointChanged = _.breakpoint !== 0
    _.opt = Object.assign({}, _._opt)
    _.breakpoint = 0
    return breakpointChanged
  }

  gliderPrototype.scrollTo = function (scrollTarget, scrollDuration, callback) {
    var _ = this

    var start = new Date().getTime()

    var animateIndex = _.animate_id

    var animate = function () {
      var now = new Date().getTime() - start
      _.ele.scrollLeft =
        _.ele.scrollLeft +
        (scrollTarget - _.ele.scrollLeft) *
        _.opt.easing(0, now, 0, 1, scrollDuration)
      if (now < scrollDuration && animateIndex === _.animate_id) {
        _window.requestAnimationFrame(animate)
      } else {
        _.ele.scrollLeft = scrollTarget
        callback && callback.call(_)
      }
    }

    _window.requestAnimationFrame(animate)
  }

  gliderPrototype.removeItem = function (index) {
    var _ = this

    if (_.slides.length) {
      _.track.removeChild(_.slides[index])
      _.refresh(true)
      _.emit('remove')
    }
  }

  gliderPrototype.addItem = function (ele) {
    var _ = this

    _.track.appendChild(ele)
    _.refresh(true)
    _.emit('add')
  }

  gliderPrototype.handleMouse = function (e) {
    var _ = this
    if (_.mouseDown) {
      _.isDrag = true
      _.ele.scrollLeft +=
        (_.mouseDown - e.clientX) * (_.opt.dragVelocity || 3.3)
      _.mouseDown = e.clientX
    }
  }

  // used to round to the nearest 0.XX fraction
  gliderPrototype.round = function (double) {
    var _ = this
    var step = _.opt.slidesToScroll % 1 || 1
    var inv = 1.0 / step
    return Math.round(double * inv) / inv
  }

  gliderPrototype.refresh = function (paging) {
    var _ = this
    _.init(true, paging)
  }

  gliderPrototype.setOption = function (opt, global) {
    var _ = this

    if (_.breakpoint && !global) {
      _._opt.responsive.forEach(function (v) {
        if (v.breakpoint === _.breakpoint) {
          v.settings = Object.assign({}, v.settings, opt)
        }
      })
    } else {
      _._opt = Object.assign({}, _._opt, opt)
    }

    _.breakpoint = 0
    _.settingsBreakpoint()
  }

  gliderPrototype.destroy = function () {
    var _ = this

    var replace = _.ele.cloneNode(true)

    var clear = function (ele) {
      ele.removeAttribute('style');
      [].forEach.call(ele.classList, function (className) {
        /^glider/.test(className) && ele.classList.remove(className)
      })
    }
    // remove track
    replace.children[0].outerHTML = replace.children[0].innerHTML
    clear(replace);
    [].forEach.call(replace.getElementsByTagName('*'), clear)
    _.ele.parentNode.replaceChild(replace, _.ele)
    _.event(_window, 'remove', {
      resize: _.resize
    })
    _.emit('destroy')
  }

  gliderPrototype.emit = function (name, arg) {
    var _ = this

    var e = new _window.CustomEvent('glider-' + name, {
      bubbles: !_.opt.eventPropagate,
      detail: arg
    })
    _.ele.dispatchEvent(e)
  }

  gliderPrototype.event = function (ele, type, args) {
    var eventHandler = ele[type + 'EventListener'].bind(ele)
    Object.keys(args).forEach(function (k) {
      eventHandler(k, args[k])
    })
  }

  return Glider
})


/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      (global = global || self, (function () {
        var current = global.Cookies;
        var exports = global.Cookies = factory();
        exports.noConflict = function () { global.Cookies = current; return exports; };
      }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

/**
 * alertifyjs 1.13.1 http://alertifyjs.com
 * AlertifyJS is a javascript framework for developing pretty browser dialogs and notifications.
 * Copyright 2019 Mohammad Younes <Mohammad@alertifyjs.com> (http://alertifyjs.com)
 * Licensed under GPL 3 <https://opensource.org/licenses/gpl-3.0>*/
( function ( window ) {
  'use strict';
  var NOT_DISABLED_NOT_RESET = ':not(:disabled):not(.ajs-reset)';
  /**
   * Keys enum
   * @type {Object}
   */
  var keys = {
    ENTER: 13,
    ESC: 27,
    F1: 112,
    F12: 123,
    LEFT: 37,
    RIGHT: 39,
    TAB: 9
  };
  /**
   * Default options
   * @type {Object}
   */
  var defaults = {
    autoReset:true,
    basic:false,
    closable:true,
    closableByDimmer:true,
    invokeOnCloseOff:false,
    frameless:false,
    defaultFocusOff:false,
    maintainFocus:true, //global default not per instance, applies to all dialogs
    maximizable:true,
    modal:true,
    movable:true,
    moveBounded:false,
    overflow:true,
    padding: true,
    pinnable:true,
    pinned:true,
    preventBodyShift:false, //global default not per instance, applies to all dialogs
    resizable:true,
    startMaximized:false,
    transition:'pulse',
    transitionOff:false,
    tabbable:['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex^="-"])'+NOT_DISABLED_NOT_RESET].join(NOT_DISABLED_NOT_RESET+','),//global
    notifier:{
      delay:5,
      position:'bottom-right',
      closeButton:false,
      classes: {
        base: 'alertify-notifier',
        prefix:'ajs-',
        message: 'ajs-message',
        top: 'ajs-top',
        right: 'ajs-right',
        bottom: 'ajs-bottom',
        left: 'ajs-left',
        center: 'ajs-center',
        visible: 'ajs-visible',
        hidden: 'ajs-hidden',
        close: 'ajs-close'
      }
    },
    glossary:{
      title:'AlertifyJS',
      ok: 'OK',
      cancel: 'Cancel',
      acccpt: 'Accept',
      deny: 'Deny',
      confirm: 'Confirm',
      decline: 'Decline',
      close: 'Close',
      maximize: 'Maximize',
      restore: 'Restore',
    },
    theme:{
      input:'ajs-input',
      ok:'ajs-ok',
      cancel:'ajs-cancel',
    },
    hooks:{
      preinit:function(){},
      postinit:function(){}
    }
  };

  //holds open dialogs instances
  var openDialogs = [];

  /**
   * [Helper]  Adds the specified class(es) to the element.
   *
   * @element {node}      The element
   * @className {string}  One or more space-separated classes to be added to the class attribute of the element.
   *
   * @return {undefined}
   */
  function addClass(element,classNames){
    element.className += ' ' + classNames;
  }

  /**
   * [Helper]  Removes the specified class(es) from the element.
   *
   * @element {node}      The element
   * @className {string}  One or more space-separated classes to be removed from the class attribute of the element.
   *
   * @return {undefined}
   */
  function removeClass(element, classNames) {
    var original = element.className.split(' ');
    var toBeRemoved = classNames.split(' ');
    for (var x = 0; x < toBeRemoved.length; x += 1) {
      var index = original.indexOf(toBeRemoved[x]);
      if (index > -1){
        original.splice(index,1);
      }
    }
    element.className = original.join(' ');
  }

  /**
   * [Helper]  Checks if the document is RTL
   *
   * @return {Boolean} True if the document is RTL, false otherwise.
   */
  function isRightToLeft(){
    return window.getComputedStyle(document.body).direction === 'rtl';
  }
  /**
   * [Helper]  Get the document current scrollTop
   *
   * @return {Number} current document scrollTop value
   */
  function getScrollTop(){
    return ((document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop);
  }

  /**
   * [Helper]  Get the document current scrollLeft
   *
   * @return {Number} current document scrollLeft value
   */
  function getScrollLeft(){
    return ((document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft);
  }

  /**
   * Helper: clear contents
   *
   */
  function clearContents(element){
    while (element.lastChild) {
      element.removeChild(element.lastChild);
    }
  }
  /**
   * Extends a given prototype by merging properties from base into sub.
   *
   * @sub {Object} sub The prototype being overwritten.
   * @base {Object} base The prototype being written.
   *
   * @return {Object} The extended prototype.
   */
  function copy(src) {
    if(null === src){
      return src;
    }
    var cpy;
    if(Array.isArray(src)){
      cpy = [];
      for(var x=0;x<src.length;x+=1){
        cpy.push(copy(src[x]));
      }
      return cpy;
    }

    if(src instanceof Date){
      return new Date(src.getTime());
    }

    if(src instanceof RegExp){
      cpy = new RegExp(src.source);
      cpy.global = src.global;
      cpy.ignoreCase = src.ignoreCase;
      cpy.multiline = src.multiline;
      cpy.lastIndex = src.lastIndex;
      return cpy;
    }

    if(typeof src === 'object'){
      cpy = {};
      // copy dialog pototype over definition.
      for (var prop in src) {
        if (src.hasOwnProperty(prop)) {
          cpy[prop] = copy(src[prop]);
        }
      }
      return cpy;
    }
    return src;
  }
  /**
   * Helper: destruct the dialog
   *
   */
  function destruct(instance, initialize){
    if(instance.elements){
      //delete the dom and it's references.
      var root = instance.elements.root;
      root.parentNode.removeChild(root);
      delete instance.elements;
      //copy back initial settings.
      instance.settings = copy(instance.__settings);
      //re-reference init function.
      instance.__init = initialize;
      //delete __internal variable to allow re-initialization.
      delete instance.__internal;
    }
  }

  /**
   * Test to check if passive event listeners are supported.
   */
  var IsPassiveSupported = false;
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function () {
        IsPassiveSupported = true;
      }
    });
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (e) {}

  /**
   * Removes an event listener
   *
   * @param {HTMLElement} el The EventTarget to register the listenr on.
   * @param {string} event The event type to listen for.
   * @param {Function} handler The function to handle the event.
   * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
   * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
   */
  var on = function (el, event, fn, useCapture, passive) {
    el.addEventListener(event, fn, IsPassiveSupported ? { capture: useCapture, passive: passive } : useCapture === true);
  };

  /**
   * Removes an event listener
   *
   * @param {HTMLElement} el The EventTarget to unregister the listenr from.
   * @param {string} event The event type to remove.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
   * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
   */
  var off = function (el, event, fn, useCapture, passive) {
    el.removeEventListener(event, fn, IsPassiveSupported ? { capture: useCapture, passive: passive } : useCapture === true);
  };

  /**
   * Prevent default event from firing
   *
   * @param  {Event} event Event object
   * @return {undefined}

   function prevent ( event ) {
        if ( event ) {
            if ( event.preventDefault ) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
        }
    }
   */
  var transition = (function () {
    var t, type;
    var supported = false;
    var transitions = {
      'animation'        : 'animationend',
      'OAnimation'       : 'oAnimationEnd oanimationend',
      'msAnimation'      : 'MSAnimationEnd',
      'MozAnimation'     : 'animationend',
      'WebkitAnimation'  : 'webkitAnimationEnd'
    };

    for (t in transitions) {
      if (document.documentElement.style[t] !== undefined) {
        type = transitions[t];
        supported = true;
        break;
      }
    }

    return {
      type: type,
      supported: supported
    };
  }());

  /**
   * Creates event handler delegate that sends the instance as last argument.
   *
   * @return {Function}    a function wrapper which sends the instance as last argument.
   */
  function delegate(context, method) {
    return function () {
      if (arguments.length > 0) {
        var args = [];
        for (var x = 0; x < arguments.length; x += 1) {
          args.push(arguments[x]);
        }
        args.push(context);
        return method.apply(context, args);
      }
      return method.apply(context, [null, context]);
    };
  }
  /**
   * Helper for creating a dialog close event.
   *
   * @return {object}
   */
  function createCloseEvent(index, button) {
    return {
      index: index,
      button: button,
      cancel: false
    };
  }
  /**
   * Helper for dispatching events.
   *
   * @param  {string} evenType The type of the event to disptach.
   * @param  {object} instance The dialog instance disptaching the event.
   *
   * @return   {any}   The result of the invoked function.
   */
  function dispatchEvent(eventType, instance) {
    if ( typeof instance.get(eventType) === 'function' ) {
      return instance.get(eventType).call(instance);
    }
  }


  /**
   * Super class for all dialogs
   *
   * @return {Object}		base dialog prototype
   */
  var dialog = (function () {
    var //holds the list of used keys.
      usedKeys = [],
      //dummy variable, used to trigger dom reflow.
      reflow = null,
      //holds body tab index in case it has any.
      tabindex = false,
      //condition for detecting safari
      isSafari = window.navigator.userAgent.indexOf('Safari') > -1 && window.navigator.userAgent.indexOf('Chrome') < 0,
      //dialog building blocks
      templates = {
        dimmer:'<div class="ajs-dimmer"></div>',
        /*tab index required to fire click event before body focus*/
        modal: '<div class="ajs-modal" tabindex="0"></div>',
        dialog: '<div class="ajs-dialog" tabindex="0"></div>',
        reset: '<button class="ajs-reset"></button>',
        commands: '<div class="ajs-commands"><button class="ajs-pin"></button><button class="ajs-maximize"></button><button class="ajs-close"></button></div>',
        header: '<div class="ajs-header"></div>',
        body: '<div class="ajs-body"></div>',
        content: '<div class="ajs-content"></div>',
        footer: '<div class="ajs-footer"></div>',
        buttons: { primary: '<div class="ajs-primary ajs-buttons"></div>', auxiliary: '<div class="ajs-auxiliary ajs-buttons"></div>' },
        button: '<button class="ajs-button"></button>',
        resizeHandle: '<div class="ajs-handle"></div>',
      },
      //common class names
      classes = {
        animationIn: 'ajs-in',
        animationOut: 'ajs-out',
        base: 'alertify',
        basic:'ajs-basic',
        capture: 'ajs-capture',
        closable:'ajs-closable',
        fixed: 'ajs-fixed',
        frameless:'ajs-frameless',
        hidden: 'ajs-hidden',
        maximize: 'ajs-maximize',
        maximized: 'ajs-maximized',
        maximizable:'ajs-maximizable',
        modeless: 'ajs-modeless',
        movable: 'ajs-movable',
        noSelection: 'ajs-no-selection',
        noOverflow: 'ajs-no-overflow',
        noPadding:'ajs-no-padding',
        pin:'ajs-pin',
        pinnable:'ajs-pinnable',
        prefix: 'ajs-',
        resizable: 'ajs-resizable',
        restore: 'ajs-restore',
        shake:'ajs-shake',
        unpinned:'ajs-unpinned',
        noTransition:'ajs-no-transition'
      };

    /**
     * Helper: initializes the dialog instance
     *
     * @return	{Number}	The total count of currently open modals.
     */
    function initialize(instance){

      if(!instance.__internal){
        //invoke preinit global hook
        alertify.defaults.hooks.preinit(instance);
        //no need to expose init after this.
        delete instance.__init;

        //keep a copy of initial dialog settings
        if(!instance.__settings){
          instance.__settings = copy(instance.settings);
        }

        //get dialog buttons/focus setup
        var setup;
        if(typeof instance.setup === 'function'){
          setup = instance.setup();
          setup.options = setup.options  || {};
          setup.focus = setup.focus  || {};
        }else{
          setup = {
            buttons:[],
            focus:{
              element:null,
              select:false
            },
            options:{
            }
          };
        }

        //initialize hooks object.
        if(typeof instance.hooks !== 'object'){
          instance.hooks = {};
        }

        //copy buttons defintion
        var buttonsDefinition = [];
        if(Array.isArray(setup.buttons)){
          for(var b=0;b<setup.buttons.length;b+=1){
            var ref  = setup.buttons[b],
              cpy = {};
            for (var i in ref) {
              if (ref.hasOwnProperty(i)) {
                cpy[i] = ref[i];
              }
            }
            buttonsDefinition.push(cpy);
          }
        }

        var internal = instance.__internal = {
          /**
           * Flag holding the open state of the dialog
           *
           * @type {Boolean}
           */
          isOpen:false,
          /**
           * Active element is the element that will receive focus after
           * closing the dialog. It defaults as the body tag, but gets updated
           * to the last focused element before the dialog was opened.
           *
           * @type {Node}
           */
          activeElement:document.body,
          timerIn:undefined,
          timerOut:undefined,
          buttons: buttonsDefinition,
          focus: setup.focus,
          options: {
            title: undefined,
            modal: undefined,
            basic:undefined,
            frameless:undefined,
            defaultFocusOff:undefined,
            pinned: undefined,
            movable: undefined,
            moveBounded:undefined,
            resizable: undefined,
            autoReset: undefined,
            closable: undefined,
            closableByDimmer: undefined,
            invokeOnCloseOff:undefined,
            maximizable: undefined,
            startMaximized: undefined,
            pinnable: undefined,
            transition: undefined,
            transitionOff: undefined,
            padding:undefined,
            overflow:undefined,
            onshow:undefined,
            onclosing:undefined,
            onclose:undefined,
            onfocus:undefined,
            onmove:undefined,
            onmoved:undefined,
            onresize:undefined,
            onresized:undefined,
            onmaximize:undefined,
            onmaximized:undefined,
            onrestore:undefined,
            onrestored:undefined
          },
          resetHandler:undefined,
          beginMoveHandler:undefined,
          beginResizeHandler:undefined,
          bringToFrontHandler:undefined,
          modalClickHandler:undefined,
          buttonsClickHandler:undefined,
          commandsClickHandler:undefined,
          transitionInHandler:undefined,
          transitionOutHandler:undefined,
          destroy:undefined
        };

        var elements = {};
        //root node
        elements.root = document.createElement('div');
        //prevent FOUC in case of async styles loading.
        elements.root.style.display = 'none';
        elements.root.className = classes.base + ' ' + classes.hidden + ' ';

        elements.root.innerHTML = templates.dimmer + templates.modal;

        //dimmer
        elements.dimmer = elements.root.firstChild;

        //dialog
        elements.modal = elements.root.lastChild;
        elements.modal.innerHTML = templates.dialog;
        elements.dialog = elements.modal.firstChild;
        elements.dialog.innerHTML = templates.reset + templates.commands + templates.header + templates.body + templates.footer + templates.resizeHandle + templates.reset;

        //reset links
        elements.reset = [];
        elements.reset.push(elements.dialog.firstChild);
        elements.reset.push(elements.dialog.lastChild);

        //commands
        elements.commands = {};
        elements.commands.container = elements.reset[0].nextSibling;
        elements.commands.pin = elements.commands.container.firstChild;
        elements.commands.maximize = elements.commands.pin.nextSibling;
        elements.commands.close = elements.commands.maximize.nextSibling;

        //header
        elements.header = elements.commands.container.nextSibling;

        //body
        elements.body = elements.header.nextSibling;
        elements.body.innerHTML = templates.content;
        elements.content = elements.body.firstChild;

        //footer
        elements.footer = elements.body.nextSibling;
        elements.footer.innerHTML = templates.buttons.auxiliary + templates.buttons.primary;

        //resize handle
        elements.resizeHandle = elements.footer.nextSibling;

        //buttons
        elements.buttons = {};
        elements.buttons.auxiliary = elements.footer.firstChild;
        elements.buttons.primary = elements.buttons.auxiliary.nextSibling;
        elements.buttons.primary.innerHTML = templates.button;
        elements.buttonTemplate = elements.buttons.primary.firstChild;
        //remove button template
        elements.buttons.primary.removeChild(elements.buttonTemplate);

        for(var x=0; x < instance.__internal.buttons.length; x+=1) {
          var button = instance.__internal.buttons[x];

          // add to the list of used keys.
          if(usedKeys.indexOf(button.key) < 0){
            usedKeys.push(button.key);
          }

          button.element = elements.buttonTemplate.cloneNode();
          button.element.innerHTML = button.text;
          if(typeof button.className === 'string' &&  button.className !== ''){
            addClass(button.element, button.className);
          }
          for(var key in button.attrs){
            if(key !== 'className' && button.attrs.hasOwnProperty(key)){
              button.element.setAttribute(key, button.attrs[key]);
            }
          }
          if(button.scope === 'auxiliary'){
            elements.buttons.auxiliary.appendChild(button.element);
          }else{
            elements.buttons.primary.appendChild(button.element);
          }
        }
        //make elements pubic
        instance.elements = elements;

        //save event handlers delegates
        internal.resetHandler = delegate(instance, onReset);
        internal.beginMoveHandler = delegate(instance, beginMove);
        internal.beginResizeHandler = delegate(instance, beginResize);
        internal.bringToFrontHandler = delegate(instance, bringToFront);
        internal.modalClickHandler = delegate(instance, modalClickHandler);
        internal.buttonsClickHandler = delegate(instance, buttonsClickHandler);
        internal.commandsClickHandler = delegate(instance, commandsClickHandler);
        internal.transitionInHandler = delegate(instance, handleTransitionInEvent);
        internal.transitionOutHandler = delegate(instance, handleTransitionOutEvent);

        //settings
        for(var opKey in internal.options){
          if(setup.options[opKey] !== undefined){
            // if found in user options
            instance.set(opKey, setup.options[opKey]);
          }else if(alertify.defaults.hasOwnProperty(opKey)) {
            // else if found in defaults options
            instance.set(opKey, alertify.defaults[opKey]);
          }else if(opKey === 'title' ) {
            // else if title key, use alertify.defaults.glossary
            instance.set(opKey, alertify.defaults.glossary[opKey]);
          }
        }

        // allow dom customization
        if(typeof instance.build === 'function'){
          instance.build();
        }

        //invoke postinit global hook
        alertify.defaults.hooks.postinit(instance);
      }

      //add to the end of the DOM tree.
      document.body.appendChild(instance.elements.root);
    }

    /**
     * Helper: maintains scroll position
     *
     */
    var scrollX, scrollY;
    function saveScrollPosition(){
      scrollX = getScrollLeft();
      scrollY = getScrollTop();
    }
    function restoreScrollPosition(){
      window.scrollTo(scrollX, scrollY);
    }

    /**
     * Helper: adds/removes no-overflow class from body
     *
     */
    function ensureNoOverflow(){
      var requiresNoOverflow = 0;
      for(var x=0;x<openDialogs.length;x+=1){
        var instance = openDialogs[x];
        if(instance.isModal() || instance.isMaximized()){
          requiresNoOverflow+=1;
        }
      }
      if(requiresNoOverflow === 0 && document.body.className.indexOf(classes.noOverflow) >= 0){
        //last open modal or last maximized one
        removeClass(document.body, classes.noOverflow);
        preventBodyShift(false);
      }else if(requiresNoOverflow > 0 && document.body.className.indexOf(classes.noOverflow) < 0){
        //first open modal or first maximized one
        preventBodyShift(true);
        addClass(document.body, classes.noOverflow);
      }
    }
    var top = '', topScroll = 0;
    /**
     * Helper: prevents body shift.
     *
     */
    function preventBodyShift(add){
      if(alertify.defaults.preventBodyShift){
        if(add && document.documentElement.scrollHeight > document.documentElement.clientHeight ){//&& openDialogs[openDialogs.length-1].elements.dialog.clientHeight <= document.documentElement.clientHeight){
          topScroll = scrollY;
          top = window.getComputedStyle(document.body).top;
          addClass(document.body, classes.fixed);
          document.body.style.top = -scrollY + 'px';
        } else if(!add) {
          scrollY = topScroll;
          document.body.style.top = top;
          removeClass(document.body, classes.fixed);
          restoreScrollPosition();
        }
      }
    }

    /**
     * Sets the name of the transition used to show/hide the dialog
     *
     * @param {Object} instance The dilog instance.
     *
     */
    function updateTransition(instance, value, oldValue){
      if(typeof oldValue === 'string'){
        removeClass(instance.elements.root,classes.prefix +  oldValue);
      }
      addClass(instance.elements.root, classes.prefix + value);
      reflow = instance.elements.root.offsetWidth;
    }

    /**
     * Toggles the dialog no transition
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function updateTransitionOff(instance){
      if (instance.get('transitionOff')) {
        // add class
        addClass(instance.elements.root, classes.noTransition);
      } else {
        // remove class
        removeClass(instance.elements.root, classes.noTransition);
      }
    }

    /**
     * Toggles the dialog display mode
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function updateDisplayMode(instance){
      if(instance.get('modal')){

        //make modal
        removeClass(instance.elements.root, classes.modeless);

        //only if open
        if(instance.isOpen()){
          unbindModelessEvents(instance);

          //in case a pinned modless dialog was made modal while open.
          updateAbsPositionFix(instance);

          ensureNoOverflow();
        }
      }else{
        //make modelss
        addClass(instance.elements.root, classes.modeless);

        //only if open
        if(instance.isOpen()){
          bindModelessEvents(instance);

          //in case pin/unpin was called while a modal is open
          updateAbsPositionFix(instance);

          ensureNoOverflow();
        }
      }
    }

    /**
     * Toggles the dialog basic view mode
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function updateBasicMode(instance){
      if (instance.get('basic')) {
        // add class
        addClass(instance.elements.root, classes.basic);
      } else {
        // remove class
        removeClass(instance.elements.root, classes.basic);
      }
    }

    /**
     * Toggles the dialog frameless view mode
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function updateFramelessMode(instance){
      if (instance.get('frameless')) {
        // add class
        addClass(instance.elements.root, classes.frameless);
      } else {
        // remove class
        removeClass(instance.elements.root, classes.frameless);
      }
    }

    /**
     * Helper: Brings the modeless dialog to front, attached to modeless dialogs.
     *
     * @param {Event} event Focus event
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function bringToFront(event, instance){

      // Do not bring to front if preceeded by an open modal
      var index = openDialogs.indexOf(instance);
      for(var x=index+1;x<openDialogs.length;x+=1){
        if(openDialogs[x].isModal()){
          return;
        }
      }

      // Bring to front by making it the last child.
      if(document.body.lastChild !== instance.elements.root){
        document.body.appendChild(instance.elements.root);
        //also make sure its at the end of the list
        openDialogs.splice(openDialogs.indexOf(instance),1);
        openDialogs.push(instance);
        setFocus(instance);
      }

      return false;
    }

    /**
     * Helper: reflects dialogs options updates
     *
     * @param {Object} instance The dilog instance.
     * @param {String} option The updated option name.
     *
     * @return	{undefined}
     */
    function optionUpdated(instance, option, oldValue, newValue){
      switch(option){
        case 'title':
          instance.setHeader(newValue);
          break;
        case 'modal':
          updateDisplayMode(instance);
          break;
        case 'basic':
          updateBasicMode(instance);
          break;
        case 'frameless':
          updateFramelessMode(instance);
          break;
        case 'pinned':
          updatePinned(instance);
          break;
        case 'closable':
          updateClosable(instance);
          break;
        case 'maximizable':
          updateMaximizable(instance);
          break;
        case 'pinnable':
          updatePinnable(instance);
          break;
        case 'movable':
          updateMovable(instance);
          break;
        case 'resizable':
          updateResizable(instance);
          break;
        case 'padding':
          if(newValue){
            removeClass(instance.elements.root, classes.noPadding);
          }else if(instance.elements.root.className.indexOf(classes.noPadding) < 0){
            addClass(instance.elements.root, classes.noPadding);
          }
          break;
        case 'overflow':
          if(newValue){
            removeClass(instance.elements.root, classes.noOverflow);
          }else if(instance.elements.root.className.indexOf(classes.noOverflow) < 0){
            addClass(instance.elements.root, classes.noOverflow);
          }
          break;
        case 'transition':
          updateTransition(instance,newValue, oldValue);
          break;
        case 'transitionOff':
          updateTransitionOff(instance);
          break;
      }

      // internal on option updated event
      if(typeof instance.hooks.onupdate === 'function'){
        instance.hooks.onupdate.call(instance, option, oldValue, newValue);
      }
    }

    /**
     * Helper: reflects dialogs options updates
     *
     * @param {Object} instance The dilog instance.
     * @param {Object} obj The object to set/get a value on/from.
     * @param {Function} callback The callback function to call if the key was found.
     * @param {String|Object} key A string specifying a propery name or a collection of key value pairs.
     * @param {Object} value Optional, the value associated with the key (in case it was a string).
     * @param {String} option The updated option name.
     *
     * @return	{Object} result object
     *	The result objects has an 'op' property, indicating of this is a SET or GET operation.
     *		GET:
     *		- found: a flag indicating if the key was found or not.
     *		- value: the property value.
     *		SET:
     *		- items: a list of key value pairs of the properties being set.
     *				each contains:
     *					- found: a flag indicating if the key was found or not.
     *					- key: the property key.
     *					- value: the property value.
     */
    function update(instance, obj, callback, key, value){
      var result = {op:undefined, items: [] };
      if(typeof value === 'undefined' && typeof key === 'string') {
        //get
        result.op = 'get';
        if(obj.hasOwnProperty(key)){
          result.found = true;
          result.value = obj[key];
        }else{
          result.found = false;
          result.value = undefined;
        }
      }
      else
      {
        var old;
        //set
        result.op = 'set';
        if(typeof key === 'object'){
          //set multiple
          var args = key;
          for (var prop in args) {
            if (obj.hasOwnProperty(prop)) {
              if(obj[prop] !== args[prop]){
                old = obj[prop];
                obj[prop] = args[prop];
                callback.call(instance,prop, old, args[prop]);
              }
              result.items.push({ 'key': prop, 'value': args[prop], 'found':true});
            }else{
              result.items.push({ 'key': prop, 'value': args[prop], 'found':false});
            }
          }
        } else if (typeof key === 'string'){
          //set single
          if (obj.hasOwnProperty(key)) {
            if(obj[key] !== value){
              old  = obj[key];
              obj[key] = value;
              callback.call(instance,key, old, value);
            }
            result.items.push({'key': key, 'value': value , 'found':true});

          }else{
            result.items.push({'key': key, 'value': value , 'found':false});
          }
        } else {
          //invalid params
          throw new Error('args must be a string or object');
        }
      }
      return result;
    }


    /**
     * Triggers a close event.
     *
     * @param {Object} instance	The dilog instance.
     *
     * @return {undefined}
     */
    function triggerClose(instance) {
      var found;
      triggerCallback(instance, function (button) {
        return found = instance.get('invokeOnCloseOff') !== true && (button.invokeOnClose === true);
      });
      //none of the buttons registered as onclose callback
      //close the dialog
      if (!found && instance.isOpen()) {
        instance.close();
      }
    }

    /**
     * Dialogs commands event handler, attached to the dialog commands element.
     *
     * @param {Event} event	DOM event object.
     * @param {Object} instance	The dilog instance.
     *
     * @return {undefined}
     */
    function commandsClickHandler(event, instance) {
      var target = event.srcElement || event.target;
      switch (target) {
        case instance.elements.commands.pin:
          if (!instance.isPinned()) {
            pin(instance);
          } else {
            unpin(instance);
          }
          break;
        case instance.elements.commands.maximize:
          if (!instance.isMaximized()) {
            maximize(instance);
          } else {
            restore(instance);
          }
          break;
        case instance.elements.commands.close:
          triggerClose(instance);
          break;
      }
      return false;
    }

    /**
     * Helper: pins the modeless dialog.
     *
     * @param {Object} instance	The dialog instance.
     *
     * @return {undefined}
     */
    function pin(instance) {
      //pin the dialog
      instance.set('pinned', true);
    }

    /**
     * Helper: unpins the modeless dialog.
     *
     * @param {Object} instance	The dilog instance.
     *
     * @return {undefined}
     */
    function unpin(instance) {
      //unpin the dialog
      instance.set('pinned', false);
    }


    /**
     * Helper: enlarges the dialog to fill the entire screen.
     *
     * @param {Object} instance	The dilog instance.
     *
     * @return {undefined}
     */
    function maximize(instance) {
      // allow custom `onmaximize` method
      dispatchEvent('onmaximize', instance);
      //maximize the dialog
      addClass(instance.elements.root, classes.maximized);
      if (instance.isOpen()) {
        ensureNoOverflow();
      }
      // allow custom `onmaximized` method
      dispatchEvent('onmaximized', instance);
    }

    /**
     * Helper: returns the dialog to its former size.
     *
     * @param {Object} instance	The dilog instance.
     *
     * @return {undefined}
     */
    function restore(instance) {
      // allow custom `onrestore` method
      dispatchEvent('onrestore', instance);
      //maximize the dialog
      removeClass(instance.elements.root, classes.maximized);
      if (instance.isOpen()) {
        ensureNoOverflow();
      }
      // allow custom `onrestored` method
      dispatchEvent('onrestored', instance);
    }

    /**
     * Show or hide the maximize box.
     *
     * @param {Object} instance The dilog instance.
     * @param {Boolean} on True to add the behavior, removes it otherwise.
     *
     * @return {undefined}
     */
    function updatePinnable(instance) {
      if (instance.get('pinnable')) {
        // add class
        addClass(instance.elements.root, classes.pinnable);
      } else {
        // remove class
        removeClass(instance.elements.root, classes.pinnable);
      }
    }

    /**
     * Helper: Fixes the absolutly positioned modal div position.
     *
     * @param {Object} instance The dialog instance.
     *
     * @return {undefined}
     */
    function addAbsPositionFix(instance) {
      var scrollLeft = getScrollLeft();
      instance.elements.modal.style.marginTop = getScrollTop() + 'px';
      instance.elements.modal.style.marginLeft = scrollLeft + 'px';
      instance.elements.modal.style.marginRight = (-scrollLeft) + 'px';
    }

    /**
     * Helper: Removes the absolutly positioned modal div position fix.
     *
     * @param {Object} instance The dialog instance.
     *
     * @return {undefined}
     */
    function removeAbsPositionFix(instance) {
      var marginTop = parseInt(instance.elements.modal.style.marginTop, 10);
      var marginLeft = parseInt(instance.elements.modal.style.marginLeft, 10);
      instance.elements.modal.style.marginTop = '';
      instance.elements.modal.style.marginLeft = '';
      instance.elements.modal.style.marginRight = '';

      if (instance.isOpen()) {
        var top = 0,
          left = 0
        ;
        if (instance.elements.dialog.style.top !== '') {
          top = parseInt(instance.elements.dialog.style.top, 10);
        }
        instance.elements.dialog.style.top = (top + (marginTop - getScrollTop())) + 'px';

        if (instance.elements.dialog.style.left !== '') {
          left = parseInt(instance.elements.dialog.style.left, 10);
        }
        instance.elements.dialog.style.left = (left + (marginLeft - getScrollLeft())) + 'px';
      }
    }
    /**
     * Helper: Adds/Removes the absolutly positioned modal div position fix based on its pinned setting.
     *
     * @param {Object} instance The dialog instance.
     *
     * @return {undefined}
     */
    function updateAbsPositionFix(instance) {
      // if modeless and unpinned add fix
      if (!instance.get('modal') && !instance.get('pinned')) {
        addAbsPositionFix(instance);
      } else {
        removeAbsPositionFix(instance);
      }
    }
    /**
     * Toggles the dialog position lock | modeless only.
     *
     * @param {Object} instance The dilog instance.
     * @param {Boolean} on True to make it modal, false otherwise.
     *
     * @return {undefined}
     */
    function updatePinned(instance) {
      if (instance.get('pinned')) {
        removeClass(instance.elements.root, classes.unpinned);
        if (instance.isOpen()) {
          removeAbsPositionFix(instance);
        }
      } else {
        addClass(instance.elements.root, classes.unpinned);
        if (instance.isOpen() && !instance.isModal()) {
          addAbsPositionFix(instance);
        }
      }
    }

    /**
     * Show or hide the maximize box.
     *
     * @param {Object} instance The dilog instance.
     * @param {Boolean} on True to add the behavior, removes it otherwise.
     *
     * @return {undefined}
     */
    function updateMaximizable(instance) {
      if (instance.get('maximizable')) {
        // add class
        addClass(instance.elements.root, classes.maximizable);
      } else {
        // remove class
        removeClass(instance.elements.root, classes.maximizable);
      }
    }

    /**
     * Show or hide the close box.
     *
     * @param {Object} instance The dilog instance.
     * @param {Boolean} on True to add the behavior, removes it otherwise.
     *
     * @return {undefined}
     */
    function updateClosable(instance) {
      if (instance.get('closable')) {
        // add class
        addClass(instance.elements.root, classes.closable);
        bindClosableEvents(instance);
      } else {
        // remove class
        removeClass(instance.elements.root, classes.closable);
        unbindClosableEvents(instance);
      }
    }


    var cancelClick = false,// flag to cancel click event if already handled by end resize event (the mousedown, mousemove, mouseup sequence fires a click event.).
      modalClickHandlerTS=0 // stores last click timestamp to prevent executing the handler twice on double click.
    ;

    /**
     * Helper: closes the modal dialog when clicking the modal
     *
     * @param {Event} event	DOM event object.
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function modalClickHandler(event, instance) {
      if(event.timeStamp - modalClickHandlerTS > 200 && (modalClickHandlerTS = event.timeStamp) && !cancelClick){
        var target = event.srcElement || event.target;
        if (instance.get('closableByDimmer') === true && target === instance.elements.modal) {
          triggerClose(instance);
        }
      }
      cancelClick = false;
    }

    // stores last call timestamp to prevent triggering the callback twice.
    var callbackTS = 0;
    // flag to cancel keyup event if already handled by click event (pressing Enter on a focusted button).
    var cancelKeyup = false;
    /**
     * Helper: triggers a button callback
     *
     * @param {Object}		The dilog instance.
     * @param {Function}	Callback to check which button triggered the event.
     *
     * @return {undefined}
     */
    function triggerCallback(instance, check) {
      if(Date.now() - callbackTS > 200 && (callbackTS = Date.now())){
        for (var idx = 0; idx < instance.__internal.buttons.length; idx += 1) {
          var button = instance.__internal.buttons[idx];
          if (!button.element.disabled && check(button)) {
            var closeEvent = createCloseEvent(idx, button);
            if (typeof instance.callback === 'function') {
              instance.callback.apply(instance, [closeEvent]);
            }
            //close the dialog only if not canceled.
            if (closeEvent.cancel === false) {
              instance.close();
            }
            break;
          }
        }
      }
    }

    /**
     * Clicks event handler, attached to the dialog footer.
     *
     * @param {Event}		DOM event object.
     * @param {Object}		The dilog instance.
     *
     * @return {undefined}
     */
    function buttonsClickHandler(event, instance) {
      var target = event.srcElement || event.target;
      triggerCallback(instance, function (button) {
        // if this button caused the click, cancel keyup event
        return button.element === target && (cancelKeyup = true);
      });
    }

    /**
     * Keyup event handler, attached to the document.body
     *
     * @param {Event}		DOM event object.
     * @param {Object}		The dilog instance.
     *
     * @return {undefined}
     */
    function keyupHandler(event) {
      //hitting enter while button has focus will trigger keyup too.
      //ignore if handled by clickHandler
      if (cancelKeyup) {
        cancelKeyup = false;
        return;
      }
      var instance = openDialogs[openDialogs.length - 1];
      var keyCode = event.keyCode;
      if (instance.__internal.buttons.length === 0 && keyCode === keys.ESC && instance.get('closable') === true) {
        triggerClose(instance);
        return false;
      }else if (usedKeys.indexOf(keyCode) > -1) {
        triggerCallback(instance, function (button) {
          return button.key === keyCode;
        });
        return false;
      }
    }
    /**
     * Keydown event handler, attached to the document.body
     *
     * @param {Event}		DOM event object.
     * @param {Object}		The dilog instance.
     *
     * @return {undefined}
     */
    function keydownHandler(event) {
      var instance = openDialogs[openDialogs.length - 1];
      var keyCode = event.keyCode;
      if (keyCode === keys.LEFT || keyCode === keys.RIGHT) {
        var buttons = instance.__internal.buttons;
        for (var x = 0; x < buttons.length; x += 1) {
          if (document.activeElement === buttons[x].element) {
            switch (keyCode) {
              case keys.LEFT:
                buttons[(x || buttons.length) - 1].element.focus();
                return;
              case keys.RIGHT:
                buttons[(x + 1) % buttons.length].element.focus();
                return;
            }
          }
        }
      }else if (keyCode < keys.F12 + 1 && keyCode > keys.F1 - 1 && usedKeys.indexOf(keyCode) > -1) {
        event.preventDefault();
        event.stopPropagation();
        triggerCallback(instance, function (button) {
          return button.key === keyCode;
        });
        return false;
      }
    }


    /**
     * Sets focus to proper dialog element
     *
     * @param {Object} instance The dilog instance.
     * @param {Node} [resetTarget=undefined] DOM element to reset focus to.
     *
     * @return {undefined}
     */
    function setFocus(instance, resetTarget) {
      // reset target has already been determined.
      if (resetTarget) {
        resetTarget.focus();
      } else {
        // current instance focus settings
        var focus = instance.__internal.focus;
        // the focus element.
        var element = focus.element;

        switch (typeof focus.element) {
          // a number means a button index
          case 'number':
            if (instance.__internal.buttons.length > focus.element) {
              //in basic view, skip focusing the buttons.
              if (instance.get('basic') === true) {
                element = instance.elements.reset[0];
              } else {
                element = instance.__internal.buttons[focus.element].element;
              }
            }
            break;
          // a string means querySelector to select from dialog body contents.
          case 'string':
            element = instance.elements.body.querySelector(focus.element);
            break;
          // a function should return the focus element.
          case 'function':
            element = focus.element.call(instance);
            break;
        }

        // if no focus element, default to first reset element.
        if (instance.get('defaultFocusOff') === true || ((typeof element === 'undefined' || element === null) && instance.__internal.buttons.length === 0)) {
          element = instance.elements.reset[0];
        }
        // focus
        if (element && element.focus) {
          element.focus();
          // if selectable
          if (focus.select && element.select) {
            element.select();
          }
        }
      }
    }

    /**
     * Focus event handler, attached to document.body and dialogs own reset links.
     * handles the focus for modal dialogs only.
     *
     * @param {Event} event DOM focus event object.
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function onReset(event, instance) {

      // should work on last modal if triggered from document.body
      if (!instance) {
        for (var x = openDialogs.length - 1; x > -1; x -= 1) {
          if (openDialogs[x].isModal()) {
            instance = openDialogs[x];
            break;
          }
        }
      }

      if(instance) {
        // if modal
        if (instance.isModal()) {
          // determine reset target to enable forward/backward tab cycle.
          var firstReset = instance.elements.reset[0],
            lastReset = instance.elements.reset[1],
            lastFocusedElement = event.relatedTarget,
            within = instance.elements.root.contains(lastFocusedElement),
            target = event.srcElement || event.target,
            resetTarget;

          //if the previous focused element element was outside the modal do nthing
          if(  /*first show */
            (target === firstReset && !within) ||
            /*focus cycle */
            (target === lastReset && lastFocusedElement === firstReset)){
            return;
          }else if(target === lastReset || target === document.body){
            resetTarget = firstReset;
          }else if(target === firstReset && lastFocusedElement === lastReset){
            resetTarget = findTabbable(instance);
          }else if(target === firstReset && within){
            resetTarget = findTabbable(instance, true);
          }
          // focus
          setFocus(instance, resetTarget);
        }
      }
    }
    function findTabbable(instance, last){
      var tabbables = [].slice.call(instance.elements.dialog.querySelectorAll(defaults.tabbable));
      if(last){
        tabbables.reverse();
      }
      for(var x=0;x<tabbables.length;x+=1){
        var tabbable = tabbables[x];
        //check if visible
        if(!!(tabbable.offsetParent || tabbable.offsetWidth || tabbable.offsetHeight || tabbable.getClientRects().length)){
          return tabbable;
        }
      }
    }
    function recycleTab(event) {
      var instance = openDialogs[openDialogs.length - 1];
      if (instance && event.shiftKey && event.keyCode === keys.TAB) {
        instance.elements.reset[1].focus();
      }
    }
    /**
     * Transition in transitionend event handler.
     *
     * @param {Event}		TransitionEnd event object.
     * @param {Object}		The dilog instance.
     *
     * @return {undefined}
     */
    function handleTransitionInEvent(event, instance) {
      // clear the timer
      clearTimeout(instance.__internal.timerIn);

      // once transition is complete, set focus
      setFocus(instance);

      // allow handling key up after transition ended.
      cancelKeyup = false;

      // allow custom `onfocus` method
      dispatchEvent('onfocus', instance);

      // unbind the event
      off(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);

      removeClass(instance.elements.root, classes.animationIn);
    }

    /**
     * Transition out transitionend event handler.
     *
     * @param {Event}		TransitionEnd event object.
     * @param {Object}		The dilog instance.
     *
     * @return {undefined}
     */
    function handleTransitionOutEvent(event, instance) {
      // clear the timer
      clearTimeout(instance.__internal.timerOut);
      // unbind the event
      off(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);

      // reset move updates
      resetMove(instance);
      // reset resize updates
      resetResize(instance);

      // restore if maximized
      if (instance.isMaximized() && !instance.get('startMaximized')) {
        restore(instance);
      }

      //destory the instance
      if (typeof instance.__internal.destroy === 'function') {
        instance.__internal.destroy.apply(instance);
      }
    }
    /* Controls moving a dialog around */
    //holde the current moving instance
    var movable = null,
      //holds the current X offset when move starts
      offsetX = 0,
      //holds the current Y offset when move starts
      offsetY = 0,
      xProp = 'pageX',
      yProp = 'pageY',
      bounds = null,
      refreshTop = false,
      moveDelegate = null
    ;

    /**
     * Helper: sets the element top/left coordinates
     *
     * @param {Event} event	DOM event object.
     * @param {Node} element The element being moved.
     *
     * @return {undefined}
     */
    function moveElement(event, element) {
      var left = (event[xProp] - offsetX),
        top  = (event[yProp] - offsetY);

      if(refreshTop){
        top -= document.body.scrollTop;
      }

      element.style.left = left + 'px';
      element.style.top = top + 'px';

    }
    /**
     * Helper: sets the element top/left coordinates within screen bounds
     *
     * @param {Event} event	DOM event object.
     * @param {Node} element The element being moved.
     *
     * @return {undefined}
     */
    function moveElementBounded(event, element) {
      var left = (event[xProp] - offsetX),
        top  = (event[yProp] - offsetY);

      if(refreshTop){
        top -= document.body.scrollTop;
      }

      element.style.left = Math.min(bounds.maxLeft, Math.max(bounds.minLeft, left)) + 'px';
      if(refreshTop){
        element.style.top = Math.min(bounds.maxTop, Math.max(bounds.minTop, top)) + 'px';
      }else{
        element.style.top = Math.max(bounds.minTop, top) + 'px';
      }
    }


    /**
     * Triggers the start of a move event, attached to the header element mouse down event.
     * Adds no-selection class to the body, disabling selection while moving.
     *
     * @param {Event} event	DOM event object.
     * @param {Object} instance The dilog instance.
     *
     * @return {Boolean} false
     */
    function beginMove(event, instance) {
      if (resizable === null && !instance.isMaximized() && instance.get('movable')) {
        var eventSrc, left=0, top=0;
        if (event.type === 'touchstart') {
          event.preventDefault();
          eventSrc = event.targetTouches[0];
          xProp = 'clientX';
          yProp = 'clientY';
        } else if (event.button === 0) {
          eventSrc = event;
        }

        if (eventSrc) {

          var element = instance.elements.dialog;
          addClass(element, classes.capture);

          if (element.style.left) {
            left = parseInt(element.style.left, 10);
          }

          if (element.style.top) {
            top = parseInt(element.style.top, 10);
          }

          offsetX = eventSrc[xProp] - left;
          offsetY = eventSrc[yProp] - top;

          if(instance.isModal()){
            offsetY += instance.elements.modal.scrollTop;
          }else if(instance.isPinned()){
            offsetY -= document.body.scrollTop;
          }

          if(instance.get('moveBounded')){
            var current = element,
              offsetLeft = -left,
              offsetTop = -top;

            //calc offset
            do {
              offsetLeft += current.offsetLeft;
              offsetTop += current.offsetTop;
            } while (current = current.offsetParent);

            bounds = {
              maxLeft : offsetLeft,
              minLeft : -offsetLeft,
              maxTop  : document.documentElement.clientHeight - element.clientHeight - offsetTop,
              minTop  : -offsetTop
            };
            moveDelegate = moveElementBounded;
          }else{
            bounds = null;
            moveDelegate = moveElement;
          }

          // allow custom `onmove` method
          dispatchEvent('onmove', instance);

          refreshTop = !instance.isModal() && instance.isPinned();
          movable = instance;
          moveDelegate(eventSrc, element);
          addClass(document.body, classes.noSelection);
          return false;
        }
      }
    }

    /**
     * The actual move handler,  attached to document.body mousemove event.
     *
     * @param {Event} event	DOM event object.
     *
     * @return {undefined}
     */
    function move(event) {
      if (movable) {
        var eventSrc;
        if (event.type === 'touchmove') {
          event.preventDefault();
          eventSrc = event.targetTouches[0];
        } else if (event.button === 0) {
          eventSrc = event;
        }
        if (eventSrc) {
          moveDelegate(eventSrc, movable.elements.dialog);
        }
      }
    }

    /**
     * Triggers the end of a move event,  attached to document.body mouseup event.
     * Removes no-selection class from document.body, allowing selection.
     *
     * @return {undefined}
     */
    function endMove() {
      if (movable) {
        var instance = movable;
        movable = bounds = null;
        removeClass(document.body, classes.noSelection);
        removeClass(instance.elements.dialog, classes.capture);
        // allow custom `onmoved` method
        dispatchEvent('onmoved', instance);
      }
    }

    /**
     * Resets any changes made by moving the element to its original state,
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function resetMove(instance) {
      movable = null;
      var element = instance.elements.dialog;
      element.style.left = element.style.top = '';
    }

    /**
     * Updates the dialog move behavior.
     *
     * @param {Object} instance The dilog instance.
     * @param {Boolean} on True to add the behavior, removes it otherwise.
     *
     * @return {undefined}
     */
    function updateMovable(instance) {
      if (instance.get('movable')) {
        // add class
        addClass(instance.elements.root, classes.movable);
        if (instance.isOpen()) {
          bindMovableEvents(instance);
        }
      } else {

        //reset
        resetMove(instance);
        // remove class
        removeClass(instance.elements.root, classes.movable);
        if (instance.isOpen()) {
          unbindMovableEvents(instance);
        }
      }
    }

    /* Controls moving a dialog around */
    //holde the current instance being resized
    var resizable = null,
      //holds the staring left offset when resize starts.
      startingLeft = Number.Nan,
      //holds the staring width when resize starts.
      startingWidth = 0,
      //holds the initial width when resized for the first time.
      minWidth = 0,
      //holds the offset of the resize handle.
      handleOffset = 0
    ;

    /**
     * Helper: sets the element width/height and updates left coordinate if neccessary.
     *
     * @param {Event} event	DOM mousemove event object.
     * @param {Node} element The element being moved.
     * @param {Boolean} pinned A flag indicating if the element being resized is pinned to the screen.
     *
     * @return {undefined}
     */
    function resizeElement(event, element, pageRelative) {

      //calculate offsets from 0,0
      var current = element;
      var offsetLeft = 0;
      var offsetTop = 0;
      do {
        offsetLeft += current.offsetLeft;
        offsetTop += current.offsetTop;
      } while (current = current.offsetParent);

      // determine X,Y coordinates.
      var X, Y;
      if (pageRelative === true) {
        X = event.pageX;
        Y = event.pageY;
      } else {
        X = event.clientX;
        Y = event.clientY;
      }
      // rtl handling
      var isRTL = isRightToLeft();
      if (isRTL) {
        // reverse X
        X = document.body.offsetWidth - X;
        // if has a starting left, calculate offsetRight
        if (!isNaN(startingLeft)) {
          offsetLeft = document.body.offsetWidth - offsetLeft - element.offsetWidth;
        }
      }

      // set width/height
      element.style.height = (Y - offsetTop + handleOffset) + 'px';
      element.style.width = (X - offsetLeft + handleOffset) + 'px';

      // if the element being resized has a starting left, maintain it.
      // the dialog is centered, divide by half the offset to maintain the margins.
      if (!isNaN(startingLeft)) {
        var diff = Math.abs(element.offsetWidth - startingWidth) * 0.5;
        if (isRTL) {
          //negate the diff, why?
          //when growing it should decrease left
          //when shrinking it should increase left
          diff *= -1;
        }
        if (element.offsetWidth > startingWidth) {
          //growing
          element.style.left = (startingLeft + diff) + 'px';
        } else if (element.offsetWidth >= minWidth) {
          //shrinking
          element.style.left = (startingLeft - diff) + 'px';
        }
      }
    }

    /**
     * Triggers the start of a resize event, attached to the resize handle element mouse down event.
     * Adds no-selection class to the body, disabling selection while moving.
     *
     * @param {Event} event	DOM event object.
     * @param {Object} instance The dilog instance.
     *
     * @return {Boolean} false
     */
    function beginResize(event, instance) {
      if (!instance.isMaximized()) {
        var eventSrc;
        if (event.type === 'touchstart') {
          event.preventDefault();
          eventSrc = event.targetTouches[0];
        } else if (event.button === 0) {
          eventSrc = event;
        }
        if (eventSrc) {
          // allow custom `onresize` method
          dispatchEvent('onresize', instance);

          resizable = instance;
          handleOffset = instance.elements.resizeHandle.offsetHeight / 2;
          var element = instance.elements.dialog;
          addClass(element, classes.capture);
          startingLeft = parseInt(element.style.left, 10);
          element.style.height = element.offsetHeight + 'px';
          element.style.minHeight = instance.elements.header.offsetHeight + instance.elements.footer.offsetHeight + 'px';
          element.style.width = (startingWidth = element.offsetWidth) + 'px';

          if (element.style.maxWidth !== 'none') {
            element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
          }
          element.style.maxWidth = 'none';
          addClass(document.body, classes.noSelection);
          return false;
        }
      }
    }

    /**
     * The actual resize handler,  attached to document.body mousemove event.
     *
     * @param {Event} event	DOM event object.
     *
     * @return {undefined}
     */
    function resize(event) {
      if (resizable) {
        var eventSrc;
        if (event.type === 'touchmove') {
          event.preventDefault();
          eventSrc = event.targetTouches[0];
        } else if (event.button === 0) {
          eventSrc = event;
        }
        if (eventSrc) {
          resizeElement(eventSrc, resizable.elements.dialog, !resizable.get('modal') && !resizable.get('pinned'));
        }
      }
    }

    /**
     * Triggers the end of a resize event,  attached to document.body mouseup event.
     * Removes no-selection class from document.body, allowing selection.
     *
     * @return {undefined}
     */
    function endResize() {
      if (resizable) {
        var instance = resizable;
        resizable = null;
        removeClass(document.body, classes.noSelection);
        removeClass(instance.elements.dialog, classes.capture);
        cancelClick = true;
        // allow custom `onresized` method
        dispatchEvent('onresized', instance);
      }
    }

    /**
     * Resets any changes made by resizing the element to its original state.
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function resetResize(instance) {
      resizable = null;
      var element = instance.elements.dialog;
      if (element.style.maxWidth === 'none') {
        //clear inline styles.
        element.style.maxWidth = element.style.minWidth = element.style.width = element.style.height = element.style.minHeight = element.style.left = '';
        //reset variables.
        startingLeft = Number.Nan;
        startingWidth = minWidth = handleOffset = 0;
      }
    }


    /**
     * Updates the dialog move behavior.
     *
     * @param {Object} instance The dilog instance.
     * @param {Boolean} on True to add the behavior, removes it otherwise.
     *
     * @return {undefined}
     */
    function updateResizable(instance) {
      if (instance.get('resizable')) {
        // add class
        addClass(instance.elements.root, classes.resizable);
        if (instance.isOpen()) {
          bindResizableEvents(instance);
        }
      } else {
        //reset
        resetResize(instance);
        // remove class
        removeClass(instance.elements.root, classes.resizable);
        if (instance.isOpen()) {
          unbindResizableEvents(instance);
        }
      }
    }

    /**
     * Reset move/resize on window resize.
     *
     * @param {Event} event	window resize event object.
     *
     * @return {undefined}
     */
    function windowResize(/*event*/) {
      for (var x = 0; x < openDialogs.length; x += 1) {
        var instance = openDialogs[x];
        if (instance.get('autoReset')) {
          resetMove(instance);
          resetResize(instance);
        }
      }
    }
    /**
     * Bind dialogs events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function bindEvents(instance) {
      // if first dialog, hook global handlers
      if (openDialogs.length === 1) {
        //global
        on(window, 'resize', windowResize);
        on(document.body, 'keyup', keyupHandler);
        on(document.body, 'keydown', keydownHandler);
        on(document.body, 'focus', onReset);

        //move
        on(document.documentElement, 'mousemove', move);
        on(document.documentElement, 'touchmove', move, false, false);
        on(document.documentElement, 'mouseup', endMove);
        on(document.documentElement, 'touchend', endMove);
        //resize
        on(document.documentElement, 'mousemove', resize);
        on(document.documentElement, 'touchmove', resize, false, false);
        on(document.documentElement, 'mouseup', endResize);
        on(document.documentElement, 'touchend', endResize);
      }

      // common events
      on(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
      on(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
      on(instance.elements.reset[0], 'focusin', instance.__internal.resetHandler);
      on(instance.elements.reset[0], 'keydown', recycleTab);
      on(instance.elements.reset[1], 'focusin', instance.__internal.resetHandler);

      //prevent handling key up when dialog is being opened by a key stroke.
      cancelKeyup = true;
      // hook in transition handler
      on(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);

      // modelss only events
      if (!instance.get('modal')) {
        bindModelessEvents(instance);
      }

      // resizable
      if (instance.get('resizable')) {
        bindResizableEvents(instance);
      }

      // movable
      if (instance.get('movable')) {
        bindMovableEvents(instance);
      }
    }

    /**
     * Unbind dialogs events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function unbindEvents(instance) {
      // if last dialog, remove global handlers
      if (openDialogs.length === 1) {
        //global
        off(window, 'resize', windowResize);
        off(document.body, 'keyup', keyupHandler);
        off(document.body, 'keydown', keydownHandler);
        off(document.body, 'focus', onReset);
        //move
        off(document.documentElement, 'mousemove', move);
        off(document.documentElement, 'mouseup', endMove);
        //resize
        off(document.documentElement, 'mousemove', resize);
        off(document.documentElement, 'mouseup', endResize);
      }

      // common events
      off(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
      off(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
      off(instance.elements.reset[0], 'focusin', instance.__internal.resetHandler);
      off(instance.elements.reset[0], 'keydown', recycleTab);
      off(instance.elements.reset[1], 'focusin', instance.__internal.resetHandler);

      // hook out transition handler
      on(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);

      // modelss only events
      if (!instance.get('modal')) {
        unbindModelessEvents(instance);
      }

      // movable
      if (instance.get('movable')) {
        unbindMovableEvents(instance);
      }

      // resizable
      if (instance.get('resizable')) {
        unbindResizableEvents(instance);
      }

    }

    /**
     * Bind modeless specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function bindModelessEvents(instance) {
      on(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
    }

    /**
     * Unbind modeless specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function unbindModelessEvents(instance) {
      off(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
    }



    /**
     * Bind movable specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function bindMovableEvents(instance) {
      on(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
      on(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler, false, false);
    }

    /**
     * Unbind movable specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function unbindMovableEvents(instance) {
      off(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
      off(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler, false, false);
    }



    /**
     * Bind resizable specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function bindResizableEvents(instance) {
      on(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
      on(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler, false, false);
    }

    /**
     * Unbind resizable specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function unbindResizableEvents(instance) {
      off(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
      off(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler, false, false);
    }

    /**
     * Bind closable events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function bindClosableEvents(instance) {
      on(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
    }

    /**
     * Unbind closable specific events
     *
     * @param {Object} instance The dilog instance.
     *
     * @return {undefined}
     */
    function unbindClosableEvents(instance) {
      off(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
    }
    // dialog API
    return {
      __init:initialize,
      /**
       * Check if dialog is currently open
       *
       * @return {Boolean}
       */
      isOpen: function () {
        return this.__internal.isOpen;
      },
      isModal: function (){
        return this.elements.root.className.indexOf(classes.modeless) < 0;
      },
      isMaximized:function(){
        return this.elements.root.className.indexOf(classes.maximized) > -1;
      },
      isPinned:function(){
        return this.elements.root.className.indexOf(classes.unpinned) < 0;
      },
      maximize:function(){
        if(!this.isMaximized()){
          maximize(this);
        }
        return this;
      },
      restore:function(){
        if(this.isMaximized()){
          restore(this);
        }
        return this;
      },
      pin:function(){
        if(!this.isPinned()){
          pin(this);
        }
        return this;
      },
      unpin:function(){
        if(this.isPinned()){
          unpin(this);
        }
        return this;
      },
      bringToFront:function(){
        bringToFront(null, this);
        return this;
      },
      /**
       * Move the dialog to a specific x/y coordinates
       *
       * @param {Number} x    The new dialog x coordinate in pixels.
       * @param {Number} y    The new dialog y coordinate in pixels.
       *
       * @return {Object} The dialog instance.
       */
      moveTo:function(x,y){
        if(!isNaN(x) && !isNaN(y)){
          // allow custom `onmove` method
          dispatchEvent('onmove', this);

          var element = this.elements.dialog,
            current = element,
            offsetLeft = 0,
            offsetTop = 0;

          //subtract existing left,top
          if (element.style.left) {
            offsetLeft -= parseInt(element.style.left, 10);
          }
          if (element.style.top) {
            offsetTop -= parseInt(element.style.top, 10);
          }
          //calc offset
          do {
            offsetLeft += current.offsetLeft;
            offsetTop += current.offsetTop;
          } while (current = current.offsetParent);

          //calc left, top
          var left = (x - offsetLeft);
          var top  = (y - offsetTop);

          //// rtl handling
          if (isRightToLeft()) {
            left *= -1;
          }

          element.style.left = left + 'px';
          element.style.top = top + 'px';

          // allow custom `onmoved` method
          dispatchEvent('onmoved', this);
        }
        return this;
      },
      /**
       * Resize the dialog to a specific width/height (the dialog must be 'resizable').
       * The dialog can be resized to:
       *  A minimum width equal to the initial display width
       *  A minimum height equal to the sum of header/footer heights.
       *
       *
       * @param {Number or String} width    The new dialog width in pixels or in percent.
       * @param {Number or String} height   The new dialog height in pixels or in percent.
       *
       * @return {Object} The dialog instance.
       */
      resizeTo:function(width,height){
        var w = parseFloat(width),
          h = parseFloat(height),
          regex = /(\d*\.\d+|\d+)%/
        ;

        if(!isNaN(w) && !isNaN(h) && this.get('resizable') === true){

          // allow custom `onresize` method
          dispatchEvent('onresize', this);

          if(('' + width).match(regex)){
            w = w / 100 * document.documentElement.clientWidth ;
          }

          if(('' + height).match(regex)){
            h = h / 100 * document.documentElement.clientHeight;
          }

          var element = this.elements.dialog;
          if (element.style.maxWidth !== 'none') {
            element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
          }
          element.style.maxWidth = 'none';
          element.style.minHeight = this.elements.header.offsetHeight + this.elements.footer.offsetHeight + 'px';
          element.style.width = w + 'px';
          element.style.height = h + 'px';

          // allow custom `onresized` method
          dispatchEvent('onresized', this);
        }
        return this;
      },
      /**
       * Gets or Sets dialog settings/options
       *
       * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
       * @param {Object} value Optional, the value associated with the key (in case it was a string).
       *
       * @return {undefined}
       */
      setting : function (key, value) {
        var self = this;
        var result = update(this, this.__internal.options, function(k,o,n){ optionUpdated(self,k,o,n); }, key, value);
        if(result.op === 'get'){
          if(result.found){
            return result.value;
          }else if(typeof this.settings !== 'undefined'){
            return update(this, this.settings, this.settingUpdated || function(){}, key, value).value;
          }else{
            return undefined;
          }
        }else if(result.op === 'set'){
          if(result.items.length > 0){
            var callback = this.settingUpdated || function(){};
            for(var x=0;x<result.items.length;x+=1){
              var item = result.items[x];
              if(!item.found && typeof this.settings !== 'undefined'){
                update(this, this.settings, callback, item.key, item.value);
              }
            }
          }
          return this;
        }
      },
      /**
       * [Alias] Sets dialog settings/options
       */
      set:function(key, value){
        this.setting(key,value);
        return this;
      },
      /**
       * [Alias] Gets dialog settings/options
       */
      get:function(key){
        return this.setting(key);
      },
      /**
       * Sets dialog header
       * @content {string or element}
       *
       * @return {undefined}
       */
      setHeader:function(content){
        if(typeof content === 'string'){
          clearContents(this.elements.header);
          this.elements.header.innerHTML = content;
        }else if (content instanceof window.HTMLElement && this.elements.header.firstChild !== content){
          clearContents(this.elements.header);
          this.elements.header.appendChild(content);
        }
        return this;
      },
      /**
       * Sets dialog contents
       * @content {string or element}
       *
       * @return {undefined}
       */
      setContent:function(content){
        if(typeof content === 'string'){
          clearContents(this.elements.content);
          this.elements.content.innerHTML = content;
        }else if (content instanceof window.HTMLElement && this.elements.content.firstChild !== content){
          clearContents(this.elements.content);
          this.elements.content.appendChild(content);
        }
        return this;
      },
      /**
       * Show the dialog as modal
       *
       * @return {Object} the dialog instance.
       */
      showModal: function(className){
        return this.show(true, className);
      },
      /**
       * Show the dialog
       *
       * @return {Object} the dialog instance.
       */
      show: function (modal, className) {

        // ensure initialization
        initialize(this);

        if ( !this.__internal.isOpen ) {

          // add to open dialogs
          this.__internal.isOpen = true;
          openDialogs.push(this);

          // save last focused element
          if(alertify.defaults.maintainFocus){
            this.__internal.activeElement = document.activeElement;
          }

          // set tabindex attribute on body element this allows script to give it focusable
          if(!document.body.hasAttribute('tabindex')) {
            document.body.setAttribute( 'tabindex', tabindex = '0');
          }

          //allow custom dom manipulation updates before showing the dialog.
          if(typeof this.prepare === 'function'){
            this.prepare();
          }

          bindEvents(this);

          if(modal !== undefined){
            this.set('modal', modal);
          }

          //save scroll to prevent document jump
          saveScrollPosition();

          ensureNoOverflow();

          // allow custom dialog class on show
          if(typeof className === 'string' && className !== ''){
            this.__internal.className = className;
            addClass(this.elements.root, className);
          }

          // maximize if start maximized
          if ( this.get('startMaximized')) {
            this.maximize();
          }else if(this.isMaximized()){
            restore(this);
          }

          updateAbsPositionFix(this);
          this.elements.root.removeAttribute('style');
          removeClass(this.elements.root, classes.animationOut);
          addClass(this.elements.root, classes.animationIn);

          // set 1s fallback in case transition event doesn't fire
          clearTimeout( this.__internal.timerIn);
          this.__internal.timerIn = setTimeout( this.__internal.transitionInHandler, transition.supported ? 1000 : 100 );

          if(isSafari){
            // force desktop safari reflow
            var root = this.elements.root;
            root.style.display  = 'none';
            setTimeout(function(){root.style.display  = 'block';}, 0);
          }

          //reflow
          reflow = this.elements.root.offsetWidth;

          // show dialog
          removeClass(this.elements.root, classes.hidden);

          //restore scroll to prevent document jump
          restoreScrollPosition();

          // internal on show event
          if(typeof this.hooks.onshow === 'function'){
            this.hooks.onshow.call(this);
          }

          // allow custom `onshow` method
          dispatchEvent('onshow', this);

        }else{
          // reset move updates
          resetMove(this);
          // reset resize updates
          resetResize(this);
          // shake the dialog to indicate its already open
          addClass(this.elements.dialog, classes.shake);
          var self = this;
          setTimeout(function(){
            removeClass(self.elements.dialog, classes.shake);
          },200);
        }
        return this;
      },
      /**
       * Close the dialog
       *
       * @return {Object} The dialog instance
       */
      close: function () {
        if (this.__internal.isOpen ) {
          // custom `onclosing` event
          if(dispatchEvent('onclosing', this) !== false){

            unbindEvents(this);

            removeClass(this.elements.root, classes.animationIn);
            addClass(this.elements.root, classes.animationOut);

            // set 1s fallback in case transition event doesn't fire
            clearTimeout( this.__internal.timerOut );
            this.__internal.timerOut = setTimeout( this.__internal.transitionOutHandler, transition.supported ? 1000 : 100 );
            // hide dialog
            addClass(this.elements.root, classes.hidden);
            //reflow
            reflow = this.elements.modal.offsetWidth;

            // return focus to the last active element
            if (alertify.defaults.maintainFocus && this.__internal.activeElement) {
              this.__internal.activeElement.focus();
              this.__internal.activeElement = null;
            }

            // remove custom dialog class on hide
            if (typeof this.__internal.className !== 'undefined' && this.__internal.className !== '') {
              removeClass(this.elements.root, this.__internal.className);
            }

            // internal on close event
            if(typeof this.hooks.onclose === 'function'){
              this.hooks.onclose.call(this);
            }

            // allow custom `onclose` method
            dispatchEvent('onclose', this);

            //remove from open dialogs
            openDialogs.splice(openDialogs.indexOf(this),1);
            this.__internal.isOpen = false;

            ensureNoOverflow();
          }

        }
        // last dialog and tab index was set by us, remove it.
        if(!openDialogs.length && tabindex === '0'){
          document.body.removeAttribute('tabindex');
        }
        return this;
      },
      /**
       * Close all open dialogs except this.
       *
       * @return {undefined}
       */
      closeOthers:function(){
        alertify.closeAll(this);
        return this;
      },
      /**
       * Destroys this dialog instance
       *
       * @return {undefined}
       */
      destroy:function(){
        if(this.__internal) {
          if (this.__internal.isOpen ) {
            //mark dialog for destruction, this will be called on tranistionOut event.
            this.__internal.destroy = function(){
              destruct(this, initialize);
            };
            //close the dialog to unbind all events.
            this.close();
          }else if(!this.__internal.destroy){
            destruct(this, initialize);
          }
        }
        return this;
      },
    };
  } () );
  var notifier = (function () {
    var reflow,
      element,
      openInstances = [],
      classes = defaults.notifier.classes,
      baseClass = classes.base;
    /**
     * Helper: initializes the notifier instance
     *
     */
    function initialize(instance) {

      if (!instance.__internal) {
        instance.__internal = {
          position: alertify.defaults.notifier.position,
          delay: alertify.defaults.notifier.delay,
        };

        element = document.createElement('DIV');
        var transitionOff = 'transitionOff' in defaults.notifier ? defaults.notifier.transitionOff : defaults.transitionOff;
        if(transitionOff){
          baseClass = classes.base + ' ajs-no-transition';
        }
        updatePosition(instance);
      }

      //add to DOM tree.
      if (element.parentNode !== document.body) {
        document.body.appendChild(element);
      }
    }

    function pushInstance(instance) {
      instance.__internal.pushed = true;
      openInstances.push(instance);
    }
    function popInstance(instance) {
      openInstances.splice(openInstances.indexOf(instance), 1);
      instance.__internal.pushed = false;
    }
    /**
     * Helper: update the notifier instance position
     *
     */
    function updatePosition(instance) {
      element.className = baseClass;
      switch (instance.__internal.position) {
        case 'top-right':
          addClass(element, classes.top + ' ' + classes.right);
          break;
        case 'top-left':
          addClass(element, classes.top + ' ' + classes.left);
          break;
        case 'top-center':
          addClass(element, classes.top + ' ' + classes.center);
          break;
        case 'bottom-left':
          addClass(element, classes.bottom + ' ' + classes.left);
          break;
        case 'bottom-center':
          addClass(element, classes.bottom + ' ' + classes.center);
          break;

        default:
        case 'bottom-right':
          addClass(element, classes.bottom + ' ' + classes.right);
          break;
      }
    }

    /**
     * creates a new notification message
     *
     * @param  {DOMElement} message	The notifier message element
     * @param  {Number} wait   Time (in ms) to wait before the message is dismissed, a value of 0 means keep open till clicked.
     * @param  {Function} callback A callback function to be invoked when the message is dismissed.
     *
     * @return {undefined}
     */
    function create(div, callback) {

      function clickDelegate(event, instance) {
        if(!instance.__internal.closeButton || event.target.getAttribute('data-close') === 'true'){
          instance.dismiss(true);
        }
      }

      function transitionDone(event, instance) {
        // unbind event
        off(instance.element, transition.type, transitionDone);
        // remove the message
        element.removeChild(instance.element);
      }

      function initialize(instance) {
        if (!instance.__internal) {
          instance.__internal = {
            pushed: false,
            delay : undefined,
            timer: undefined,
            clickHandler: undefined,
            transitionEndHandler: undefined,
            transitionTimeout: undefined
          };
          instance.__internal.clickHandler = delegate(instance, clickDelegate);
          instance.__internal.transitionEndHandler = delegate(instance, transitionDone);
        }
        return instance;
      }
      function clearTimers(instance) {
        clearTimeout(instance.__internal.timer);
        clearTimeout(instance.__internal.transitionTimeout);
      }
      return initialize({
        /* notification DOM element*/
        element: div,
        /*
                 * Pushes a notification message
                 * @param {string or DOMElement} content The notification message content
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */
        push: function (_content, _wait) {
          if (!this.__internal.pushed) {

            pushInstance(this);
            clearTimers(this);

            var content, wait;
            switch (arguments.length) {
              case 0:
                wait = this.__internal.delay;
                break;
              case 1:
                if (typeof (_content) === 'number') {
                  wait = _content;
                } else {
                  content = _content;
                  wait = this.__internal.delay;
                }
                break;
              case 2:
                content = _content;
                wait = _wait;
                break;
            }
            this.__internal.closeButton = alertify.defaults.notifier.closeButton;
            // set contents
            if (typeof content !== 'undefined') {
              this.setContent(content);
            }
            // append or insert
            if (notifier.__internal.position.indexOf('top') < 0) {
              element.appendChild(this.element);
            } else {
              element.insertBefore(this.element, element.firstChild);
            }
            reflow = this.element.offsetWidth;
            addClass(this.element, classes.visible);
            // attach click event
            on(this.element, 'click', this.__internal.clickHandler);
            return this.delay(wait);
          }
          return this;
        },
        /*
                 * {Function} callback function to be invoked before dismissing the notification message.
                 * Remarks: A return value === 'false' will cancel the dismissal
                 *
                 */
        ondismiss: function () { },
        /*
                 * {Function} callback function to be invoked when the message is dismissed.
                 *
                 */
        callback: callback,
        /*
                 * Dismisses the notification message
                 * @param {Boolean} clicked A flag indicating if the dismissal was caused by a click.
                 *
                 */
        dismiss: function (clicked) {
          if (this.__internal.pushed) {
            clearTimers(this);
            if (!(typeof this.ondismiss === 'function' && this.ondismiss.call(this) === false)) {
              //detach click event
              off(this.element, 'click', this.__internal.clickHandler);
              // ensure element exists
              if (typeof this.element !== 'undefined' && this.element.parentNode === element) {
                //transition end or fallback
                this.__internal.transitionTimeout = setTimeout(this.__internal.transitionEndHandler, transition.supported ? 1000 : 100);
                removeClass(this.element, classes.visible);

                // custom callback on dismiss
                if (typeof this.callback === 'function') {
                  this.callback.call(this, clicked);
                }
              }
              popInstance(this);
            }
          }
          return this;
        },
        /*
                 * Delays the notification message dismissal
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */
        delay: function (wait) {
          clearTimers(this);
          this.__internal.delay = typeof wait !== 'undefined' && !isNaN(+wait) ? +wait : notifier.__internal.delay;
          if (this.__internal.delay > 0) {
            var  self = this;
            this.__internal.timer = setTimeout(function () { self.dismiss(); }, this.__internal.delay * 1000);
          }
          return this;
        },
        /*
                 * Sets the notification message contents
                 * @param {string or DOMElement} content The notification message content
                 *
                 */
        setContent: function (content) {
          if (typeof content === 'string') {
            clearContents(this.element);
            this.element.innerHTML = content;
          } else if (content instanceof window.HTMLElement && this.element.firstChild !== content) {
            clearContents(this.element);
            this.element.appendChild(content);
          }
          if(this.__internal.closeButton){
            var close = document.createElement('span');
            addClass(close, classes.close);
            close.setAttribute('data-close', true);
            this.element.appendChild(close);
          }
          return this;
        },
        /*
                 * Dismisses all open notifications except this.
                 *
                 */
        dismissOthers: function () {
          notifier.dismissAll(this);
          return this;
        }
      });
    }

    //notifier api
    return {
      /**
       * Gets or Sets notifier settings.
       *
       * @param {string} key The setting name
       * @param {Variant} value The setting value.
       *
       * @return {Object}	if the called as a setter, return the notifier instance.
       */
      setting: function (key, value) {
        //ensure init
        initialize(this);

        if (typeof value === 'undefined') {
          //get
          return this.__internal[key];
        } else {
          //set
          switch (key) {
            case 'position':
              this.__internal.position = value;
              updatePosition(this);
              break;
            case 'delay':
              this.__internal.delay = value;
              break;
          }
        }
        return this;
      },
      /**
       * [Alias] Sets dialog settings/options
       */
      set:function(key,value){
        this.setting(key,value);
        return this;
      },
      /**
       * [Alias] Gets dialog settings/options
       */
      get:function(key){
        return this.setting(key);
      },
      /**
       * Creates a new notification message
       *
       * @param {string} type The type of notification message (simply a CSS class name 'ajs-{type}' to be added).
       * @param {Function} callback  A callback function to be invoked when the message is dismissed.
       *
       * @return {undefined}
       */
      create: function (type, callback) {
        //ensure notifier init
        initialize(this);
        //create new notification message
        var div = document.createElement('div');
        div.className = classes.message + ((typeof type === 'string' && type !== '') ? ' ' + classes.prefix + type : '');
        return create(div, callback);
      },
      /**
       * Dismisses all open notifications.
       *
       * @param {Object} excpet [optional] The notification object to exclude from dismissal.
       *
       */
      dismissAll: function (except) {
        var clone = openInstances.slice(0);
        for (var x = 0; x < clone.length; x += 1) {
          var  instance = clone[x];
          if (except === undefined || except !== instance) {
            instance.dismiss();
          }
        }
      }
    };
  })();

  /**
   * Alertify public API
   * This contains everything that is exposed through the alertify object.
   *
   * @return {Object}
   */
  function Alertify() {

    // holds a references of created dialogs
    var dialogs = {};

    /**
     * Extends a given prototype by merging properties from base into sub.
     *
     * @sub {Object} sub The prototype being overwritten.
     * @base {Object} base The prototype being written.
     *
     * @return {Object} The extended prototype.
     */
    function extend(sub, base) {
      // copy dialog pototype over definition.
      for (var prop in base) {
        if (base.hasOwnProperty(prop)) {
          sub[prop] = base[prop];
        }
      }
      return sub;
    }


    /**
     * Helper: returns a dialog instance from saved dialogs.
     * and initializes the dialog if its not already initialized.
     *
     * @name {String} name The dialog name.
     *
     * @return {Object} The dialog instance.
     */
    function get_dialog(name) {
      var dialog = dialogs[name].dialog;
      //initialize the dialog if its not already initialized.
      if (dialog && typeof dialog.__init === 'function') {
        dialog.__init(dialog);
      }
      return dialog;
    }

    /**
     * Helper:  registers a new dialog definition.
     *
     * @name {String} name The dialog name.
     * @Factory {Function} Factory a function resposible for creating dialog prototype.
     * @transient {Boolean} transient True to create a new dialog instance each time the dialog is invoked, false otherwise.
     * @base {String} base the name of another dialog to inherit from.
     *
     * @return {Object} The dialog definition.
     */
    function register(name, Factory, transient, base) {
      var definition = {
        dialog: null,
        factory: Factory
      };

      //if this is based on an existing dialog, create a new definition
      //by applying the new protoype over the existing one.
      if (base !== undefined) {
        definition.factory = function () {
          return extend(new dialogs[base].factory(), new Factory());
        };
      }

      if (!transient) {
        //create a new definition based on dialog
        definition.dialog = extend(new definition.factory(), dialog);
      }
      return dialogs[name] = definition;
    }

    return {
      /**
       * Alertify defaults
       *
       * @type {Object}
       */
      defaults: defaults,
      /**
       * Dialogs factory
       *
       * @param {string}      Dialog name.
       * @param {Function}    A Dialog factory function.
       * @param {Boolean}     Indicates whether to create a singleton or transient dialog.
       * @param {String}      The name of the base type to inherit from.
       */
      dialog: function (name, Factory, transient, base) {

        // get request, create a new instance and return it.
        if (typeof Factory !== 'function') {
          return get_dialog(name);
        }

        if (this.hasOwnProperty(name)) {
          throw new Error('alertify.dialog: name already exists');
        }

        // register the dialog
        var definition = register(name, Factory, transient, base);

        if (transient) {

          // make it public
          this[name] = function () {
            //if passed with no params, consider it a get request
            if (arguments.length === 0) {
              return definition.dialog;
            } else {
              var instance = extend(new definition.factory(), dialog);
              //ensure init
              if (instance && typeof instance.__init === 'function') {
                instance.__init(instance);
              }
              instance['main'].apply(instance, arguments);
              return instance['show'].apply(instance);
            }
          };
        } else {
          // make it public
          this[name] = function () {
            //ensure init
            if (definition.dialog && typeof definition.dialog.__init === 'function') {
              definition.dialog.__init(definition.dialog);
            }
            //if passed with no params, consider it a get request
            if (arguments.length === 0) {
              return definition.dialog;
            } else {
              var dialog = definition.dialog;
              dialog['main'].apply(definition.dialog, arguments);
              return dialog['show'].apply(definition.dialog);
            }
          };
        }
      },
      /**
       * Close all open dialogs.
       *
       * @param {Object} excpet [optional] The dialog object to exclude from closing.
       *
       * @return {undefined}
       */
      closeAll: function (except) {
        var clone = openDialogs.slice(0);
        for (var x = 0; x < clone.length; x += 1) {
          var instance = clone[x];
          if (except === undefined || except !== instance) {
            instance.close();
          }
        }
      },
      /**
       * Gets or Sets dialog settings/options. if the dialog is transient, this call does nothing.
       *
       * @param {string} name The dialog name.
       * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
       * @param {Variant} value Optional, the value associated with the key (in case it was a string).
       *
       * @return {undefined}
       */
      setting: function (name, key, value) {

        if (name === 'notifier') {
          return notifier.setting(key, value);
        }

        var dialog = get_dialog(name);
        if (dialog) {
          return dialog.setting(key, value);
        }
      },
      /**
       * [Alias] Sets dialog settings/options
       */
      set: function(name,key,value){
        return this.setting(name, key,value);
      },
      /**
       * [Alias] Gets dialog settings/options
       */
      get: function(name, key){
        return this.setting(name, key);
      },
      /**
       * Creates a new notification message.
       * If a type is passed, a class name "ajs-{type}" will be added.
       * This allows for custom look and feel for various types of notifications.
       *
       * @param  {String | DOMElement}    [message=undefined]		Message text
       * @param  {String}                 [type='']				Type of log message
       * @param  {String}                 [wait='']				Time (in seconds) to wait before auto-close
       * @param  {Function}               [callback=undefined]	A callback function to be invoked when the log is closed.
       *
       * @return {Object} Notification object.
       */
      notify: function (message, type, wait, callback) {
        return notifier.create(type, callback).push(message, wait);
      },
      /**
       * Creates a new notification message.
       *
       * @param  {String}		[message=undefined]		Message text
       * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
       * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
       *
       * @return {Object} Notification object.
       */
      message: function (message, wait, callback) {
        return notifier.create(null, callback).push(message, wait);
      },
      /**
       * Creates a new notification message of type 'success'.
       *
       * @param  {String}		[message=undefined]		Message text
       * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
       * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
       *
       * @return {Object} Notification object.
       */
      success: function (message, wait, callback) {
        return notifier.create('success', callback).push(message, wait);
      },
      /**
       * Creates a new notification message of type 'error'.
       *
       * @param  {String}		[message=undefined]		Message text
       * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
       * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
       *
       * @return {Object} Notification object.
       */
      error: function (message, wait, callback) {
        return notifier.create('error', callback).push(message, wait);
      },
      /**
       * Creates a new notification message of type 'warning'.
       *
       * @param  {String}		[message=undefined]		Message text
       * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
       * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
       *
       * @return {Object} Notification object.
       */
      warning: function (message, wait, callback) {
        return notifier.create('warning', callback).push(message, wait);
      },
      /**
       * Dismisses all open notifications
       *
       * @return {undefined}
       */
      dismissAll: function () {
        notifier.dismissAll();
      }
    };
  }
  var alertify = new Alertify();

  /**
   * Alert dialog definition
   *
   * invoked by:
   *	alertify.alert(message);
   *	alertify.alert(title, message);
   *	alertify.alert(message, onok);
   *	alertify.alert(title, message, onok);
   */
  alertify.dialog('alert', function () {
    return {
      main: function (_title, _message, _onok) {
        var title, message, onok;
        switch (arguments.length) {
          case 1:
            message = _title;
            break;
          case 2:
            if (typeof _message === 'function') {
              message = _title;
              onok = _message;
            } else {
              title = _title;
              message = _message;
            }
            break;
          case 3:
            title = _title;
            message = _message;
            onok = _onok;
            break;
        }
        this.set('title', title);
        this.set('message', message);
        this.set('onok', onok);
        return this;
      },
      setup: function () {
        return {
          buttons: [
            {
              text: alertify.defaults.glossary.ok,
              key: keys.ESC,
              invokeOnClose: true,
              className: alertify.defaults.theme.ok,
            }
          ],
          focus: {
            element: 0,
            select: false
          },
          options: {
            maximizable: false,
            resizable: false
          }
        };
      },
      build: function () {
        // nothing
      },
      prepare: function () {
        //nothing
      },
      setMessage: function (message) {
        this.setContent(message);
      },
      settings: {
        message: undefined,
        onok: undefined,
        label: undefined,
      },
      settingUpdated: function (key, oldValue, newValue) {
        switch (key) {
          case 'message':
            this.setMessage(newValue);
            break;
          case 'label':
            if (this.__internal.buttons[0].element) {
              this.__internal.buttons[0].element.innerHTML = newValue;
            }
            break;
        }
      },
      callback: function (closeEvent) {
        if (typeof this.get('onok') === 'function') {
          var returnValue = this.get('onok').call(this, closeEvent);
          if (typeof returnValue !== 'undefined') {
            closeEvent.cancel = !returnValue;
          }
        }
      }
    };
  });
  /**
   * Confirm dialog object
   *
   *	alertify.confirm(message);
   *	alertify.confirm(message, onok);
   *	alertify.confirm(message, onok, oncancel);
   *	alertify.confirm(title, message, onok, oncancel);
   */
  alertify.dialog('confirm', function () {

    var autoConfirm = {
      timer: null,
      index: null,
      text: null,
      duration: null,
      task: function (event, self) {
        if (self.isOpen()) {
          self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text + ' (&#8207;' + autoConfirm.duration + '&#8207;) ';
          autoConfirm.duration -= 1;
          if (autoConfirm.duration === -1) {
            clearAutoConfirm(self);
            var button = self.__internal.buttons[autoConfirm.index];
            var closeEvent = createCloseEvent(autoConfirm.index, button);

            if (typeof self.callback === 'function') {
              self.callback.apply(self, [closeEvent]);
            }
            //close the dialog.
            if (closeEvent.close !== false) {
              self.close();
            }
          }
        } else {
          clearAutoConfirm(self);
        }
      }
    };

    function clearAutoConfirm(self) {
      if (autoConfirm.timer !== null) {
        clearInterval(autoConfirm.timer);
        autoConfirm.timer = null;
        self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text;
      }
    }

    function startAutoConfirm(self, index, duration) {
      clearAutoConfirm(self);
      autoConfirm.duration = duration;
      autoConfirm.index = index;
      autoConfirm.text = self.__internal.buttons[index].element.innerHTML;
      autoConfirm.timer = setInterval(delegate(self, autoConfirm.task), 1000);
      autoConfirm.task(null, self);
    }


    return {
      main: function (_title, _message, _onok, _oncancel) {
        var title, message, onok, oncancel;
        switch (arguments.length) {
          case 1:
            message = _title;
            break;
          case 2:
            message = _title;
            onok = _message;
            break;
          case 3:
            message = _title;
            onok = _message;
            oncancel = _onok;
            break;
          case 4:
            title = _title;
            message = _message;
            onok = _onok;
            oncancel = _oncancel;
            break;
        }
        this.set('title', title);
        this.set('message', message);
        this.set('onok', onok);
        this.set('oncancel', oncancel);
        return this;
      },
      setup: function () {
        return {
          buttons: [
            {
              text: alertify.defaults.glossary.ok,
              key: keys.ENTER,
              className: alertify.defaults.theme.ok,
            },
            {
              text: alertify.defaults.glossary.cancel,
              key: keys.ESC,
              invokeOnClose: true,
              className: alertify.defaults.theme.cancel,
            }
          ],
          focus: {
            element: 0,
            select: false
          },
          options: {
            maximizable: false,
            resizable: false
          }
        };
      },
      build: function () {
        //nothing
      },
      prepare: function () {
        //nothing
      },
      setMessage: function (message) {
        this.setContent(message);
      },
      settings: {
        message: null,
        labels: null,
        onok: null,
        oncancel: null,
        defaultFocus: null,
        reverseButtons: null,
      },
      settingUpdated: function (key, oldValue, newValue) {
        switch (key) {
          case 'message':
            this.setMessage(newValue);
            break;
          case 'labels':
            if ('ok' in newValue && this.__internal.buttons[0].element) {
              this.__internal.buttons[0].text = newValue.ok;
              this.__internal.buttons[0].element.innerHTML = newValue.ok;
            }
            if ('cancel' in newValue && this.__internal.buttons[1].element) {
              this.__internal.buttons[1].text = newValue.cancel;
              this.__internal.buttons[1].element.innerHTML = newValue.cancel;
            }
            break;
          case 'reverseButtons':
            if (newValue === true) {
              this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
            } else {
              this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
            }
            break;
          case 'defaultFocus':
            this.__internal.focus.element = newValue === 'ok' ? 0 : 1;
            break;
        }
      },
      callback: function (closeEvent) {
        clearAutoConfirm(this);
        var returnValue;
        switch (closeEvent.index) {
          case 0:
            if (typeof this.get('onok') === 'function') {
              returnValue = this.get('onok').call(this, closeEvent);
              if (typeof returnValue !== 'undefined') {
                closeEvent.cancel = !returnValue;
              }
            }
            break;
          case 1:
            if (typeof this.get('oncancel') === 'function') {
              returnValue = this.get('oncancel').call(this, closeEvent);
              if (typeof returnValue !== 'undefined') {
                closeEvent.cancel = !returnValue;
              }
            }
            break;
        }
      },
      autoOk: function (duration) {
        startAutoConfirm(this, 0, duration);
        return this;
      },
      autoCancel: function (duration) {
        startAutoConfirm(this, 1, duration);
        return this;
      }
    };
  });
  /**
   * Prompt dialog object
   *
   * invoked by:
   *	alertify.prompt(message);
   *	alertify.prompt(message, value);
   *	alertify.prompt(message, value, onok);
   *	alertify.prompt(message, value, onok, oncancel);
   *	alertify.prompt(title, message, value, onok, oncancel);
   */
  alertify.dialog('prompt', function () {
    var input = document.createElement('INPUT');
    var p = document.createElement('P');
    return {
      main: function (_title, _message, _value, _onok, _oncancel) {
        var title, message, value, onok, oncancel;
        switch (arguments.length) {
          case 1:
            message = _title;
            break;
          case 2:
            message = _title;
            value = _message;
            break;
          case 3:
            message = _title;
            value = _message;
            onok = _value;
            break;
          case 4:
            message = _title;
            value = _message;
            onok = _value;
            oncancel = _onok;
            break;
          case 5:
            title = _title;
            message = _message;
            value = _value;
            onok = _onok;
            oncancel = _oncancel;
            break;
        }
        this.set('title', title);
        this.set('message', message);
        this.set('value', value);
        this.set('onok', onok);
        this.set('oncancel', oncancel);
        return this;
      },
      setup: function () {
        return {
          buttons: [
            {
              text: alertify.defaults.glossary.ok,
              key: keys.ENTER,
              className: alertify.defaults.theme.ok,
            },
            {
              text: alertify.defaults.glossary.cancel,
              key: keys.ESC,
              invokeOnClose: true,
              className: alertify.defaults.theme.cancel,
            }
          ],
          focus: {
            element: input,
            select: true
          },
          options: {
            maximizable: false,
            resizable: false
          }
        };
      },
      build: function () {
        input.className = alertify.defaults.theme.input;
        input.setAttribute('type', 'text');
        input.value = this.get('value');
        this.elements.content.appendChild(p);
        this.elements.content.appendChild(input);
      },
      prepare: function () {
        //nothing
      },
      setMessage: function (message) {
        if (typeof message === 'string') {
          clearContents(p);
          p.innerHTML = message;
        } else if (message instanceof window.HTMLElement && p.firstChild !== message) {
          clearContents(p);
          p.appendChild(message);
        }
      },
      settings: {
        message: undefined,
        labels: undefined,
        onok: undefined,
        oncancel: undefined,
        value: '',
        type:'text',
        reverseButtons: undefined,
      },
      settingUpdated: function (key, oldValue, newValue) {
        switch (key) {
          case 'message':
            this.setMessage(newValue);
            break;
          case 'value':
            input.value = newValue;
            break;
          case 'type':
            switch (newValue) {
              case 'text':
              case 'color':
              case 'date':
              case 'datetime-local':
              case 'email':
              case 'month':
              case 'number':
              case 'password':
              case 'search':
              case 'tel':
              case 'time':
              case 'week':
                input.type = newValue;
                break;
              default:
                input.type = 'text';
                break;
            }
            break;
          case 'labels':
            if (newValue.ok && this.__internal.buttons[0].element) {
              this.__internal.buttons[0].element.innerHTML = newValue.ok;
            }
            if (newValue.cancel && this.__internal.buttons[1].element) {
              this.__internal.buttons[1].element.innerHTML = newValue.cancel;
            }
            break;
          case 'reverseButtons':
            if (newValue === true) {
              this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
            } else {
              this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
            }
            break;
        }
      },
      callback: function (closeEvent) {
        var returnValue;
        switch (closeEvent.index) {
          case 0:
            this.settings.value = input.value;
            if (typeof this.get('onok') === 'function') {
              returnValue = this.get('onok').call(this, closeEvent, this.settings.value);
              if (typeof returnValue !== 'undefined') {
                closeEvent.cancel = !returnValue;
              }
            }
            break;
          case 1:
            if (typeof this.get('oncancel') === 'function') {
              returnValue = this.get('oncancel').call(this, closeEvent);
              if (typeof returnValue !== 'undefined') {
                closeEvent.cancel = !returnValue;
              }
            }
            if(!closeEvent.cancel){
              input.value = this.settings.value;
            }
            break;
        }
      }
    };
  });

  // CommonJS
  if ( typeof module === 'object' && typeof module.exports === 'object' ) {
    module.exports = alertify;
    // AMD
  } else if ( typeof define === 'function' && define.amd) {
    define( [], function () {
      return alertify;
    } );
    // window
  } else if ( !window.alertify ) {
    window.alertify = alertify;
  }

} ( typeof window !== 'undefined' ? window : this ) );